<template>
  <div>
    <modal
      v-show="showImageVisible"
      @close="closeImageModal"
      modalIsLarge
      footer
    >
      <template v-slot:title>
        <h4>Image</h4>
      </template>
      <template v-slot:body>
        <div class="d-inline-flex justify-content-center w-100">
          <div class="p-4 w-75">
            <img
              :src="imageModalQuery"
              style="height: 250px"
              class="w-100"
              alt=""
            />
          </div>
        </div>
      </template>
      <template v-slot:footer>
        <button class="btn btn-danger" @click="closeImageModal">Close</button>
      </template>
    </modal>
    <modal
      v-show="addAccountToCustomerModal"
      @close="addAccountToCustomerModal = false"
      footer
      modalIsLarge
    >
      <template v-slot:title>
            <li class="nav-item">
              <a
                class="nav-link"
                href="javascript:void(0)"
                v-on:click="activetab = 8"
                v-bind:class="[activetab === 8 ? 'active' : '']"
                >Change Requests</a
              >
            </li>
        <h5>Account Details From CBA</h5>
      </template>
      <template v-slot:body>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label for="title">Account Number</label>
              <input
                type="text"
                class="form-control"
                name="title"
                v-model="cba_account_number"
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="title">&nbsp;</label>
              <button
                @click.prevent="addAccountToCustomer('preview')"
                :disabled="get_cba_account_detail_loading"
                class="btn btn-primary form-control"
              >
                <span
                  class="custom-loader"
                  v-if="get_cba_account_detail_loading"
                >
                  <loader-icon size="1.5x" class="custom-class"></loader-icon>
                  <span style="font-weight: 600; text-transform: initial;"
                    >Fetching Account Details...</span
                  >
                </span>
                <span v-else>
                  Get Account Details
                </span>
              </button>
            </div>
          </div>
        </div>
        <div class="row" v-if="addAccountToCustomerDetail">
          <div class="col-md-12">
            <KeyValue
              objKey="Account Name"
              :objValue="addAccountToCustomerDetail.account_name"
            />
          </div>
          <div class="col-md-12">
            <KeyValue
              objKey="Account Number "
              :objValue="addAccountToCustomerDetail.account_number"
            />
          </div>
          <div class="col-md-12">
            <KeyValue
              objKey="Customer Number "
              :objValue="addAccountToCustomerDetail.customer_number"
            />
          </div>
        </div>
      </template>
      <template v-slot:footer>
        <button
          class="btn btn-success text-white"
          @click.prevent="addAccountToCustomer('submit')"
          v-if="addAccountToCustomerDetail"
          :disabled="get_cba_account_detail_loading"
        >
          <span class="custom-loader" v-if="get_cba_account_detail_loading">
            <loader-icon size="1.5x" class="custom-class"></loader-icon>
            <span style="font-weight: 600; text-transform: initial;"
              >Creating Account...</span
            >
          </span>
          <span v-else>
            Create Account
          </span>
        </button>
        <button
          @click.prevent="closeAddAccountToCustomerModal"
          class="btn btn-secondary"
        >
          Cancel
        </button>
      </template>
    </modal>
    <form @submit.prevent="sendMessageProcess">
      <modal
        v-show="isSendMessageModalVisible"
        @close="closeSendMessageModal"
        footer
      >
        <template v-slot:title>
          <h5>Send Message To Customer</h5>
        </template>
        <template v-slot:body>
          <div class=" form-group">
            <label for="title">Title</label>
            <input
              type="text"
              v-model="sendMessageObj.title"
              placeholder="Title Heading"
              class="form-control"
            />
          </div>

          <div class="form-group">
            <label for="type">Type</label>
            <select
              name=""
              id=""
              class="form-control"
              v-model="sendMessageObj.type"
            >
              <option value="" selected disabled>Please Select Type</option>
              <option value="push">Push</option>
              <option value="sms">SMS</option>
              <option value="email">Email</option>
            </select>
          </div>

          <div class=" form-group">
            <label for="message">Message</label>
            <textarea
              name=""
              id=""
              cols="30"
              class=" form-control"
              rows="10"
              v-model="sendMessageObj.message"
              style="resize: none"
              placeholder="Message"
            ></textarea>
          </div>
        </template>
        <template v-slot:footer>
          <button
            type="submit"
            class="button"
            :disabled="
              sendMessageObj.title === '' ||
                sendMessageObj.type === '' ||
                sendMessageObj.message === '' ||
                sendMessageLoading
            "
          >
            <span v-if="sendMessageLoading">Please wait...</span>
            <span v-else>Proceed</span>
          </button>
          <button
            type="button"
            class="btn btn-secondary"
            data-dismiss="modal"
            @click="addAccountToCustomerModal = false"
          >
            Cancel
          </button>
        </template>
      </modal>
    </form>

    <form @submit.prevent="updateVirtualAccountPrefix">
      <modal
        v-show="isVirtualAccountModalVisible"
        @close="closeVirtualAccountModal"
        footer
      >
        <template v-slot:title>
          <h5>Virtual Acccount Setting</h5>
        </template>
        <template v-slot:body>
          <div class="form-group">
            <label for="type">Virtual Account Usage</label>
            <select
              name=""
              id=""
              class="form-control"
              v-model="selectedAccount.virtual_account_usage"
            >
              <option value="" selected disabled>Please Select Access</option>
              <option value="no">NO</option>
              <option value="yes">YES</option>
            </select>
          </div>
          <div class=" form-group" v-if="selectedAccount.virtual_account_usage === 'yes'">
            <label for="title">Prefix</label>
            <input
              type="text"
              v-model="selectedAccount.virtual_account_prefix"
              placeholder="Prefix"
              class="form-control"
            />
          </div>
        </template>
        <template v-slot:footer>
          <button
            type="submit"
            class="button"
          >
            <span v-if="sendMessageLoading">Please wait...</span>
            <span v-else>Proceed</span>
          </button>
          <button
            type="button"
            class="btn btn-secondary"
            data-dismiss="modal"
            @click="closeVirtualAccountModal"
          >
            Cancel
          </button>
        </template>
      </modal>
    </form>

    </form>

    <form @submit.prevent="promptSaveKycLimitOverride">
      <modal
        v-show="isKycLimitOverrideModalVisible"
        @close="closeKycLimitOverrideModal"
        footer
      >
        <template v-slot:title>
          <h5>Temporary KYC Limit Override</h5>
        </template>
        <template v-slot:body>
          <p class="text-muted">
            This replaces one KYC level limit for this customer until the time you set.
            Removing it, or waiting for that time, restores the level limit.
          </p>
          <div class="form-group">
            <label>Limit</label>
            <select class="form-control" v-model="kycLimitOverride.limit_key" required>
              <option value="">Select a limit</option>
              <option v-for="limit in kycLimitOptions" :key="limit.key" :value="limit.key">
                {{ limit.label }} (level: {{ limit.level_value || "—" }})
              </option>
            </select>
          </div>
          <div class="form-group">
            <label>Override amount</label>
            <input
              type="number"
              min="0"
              step="0.01"
              class="form-control"
              v-model="kycLimitOverride.override_value"
              required
            />
          </div>
          <div class="form-group">
            <label>Expires at</label>
            <input
              type="datetime-local"
              class="form-control"
              v-model="kycLimitOverride.expires_at"
              required
            />
          </div>
          <div class="form-group">
            <label>Reason (optional)</label>
            <input
              type="text"
              class="form-control"
              v-model="kycLimitOverride.reason"
              placeholder="Why this customer needs a higher limit"
            />
          </div>
        </template>
        <template v-slot:footer>
          <button type="submit" class="button" :disabled="!kycLimitOverrideFormValid">
            Proceed
          </button>
          <button
            type="button"
            class="btn btn-secondary"
            @click="closeKycLimitOverrideModal"
          >
            Cancel
          </button>
        </template>
      </modal>
    </form>

    <form @submit.prevent="promptSavePatternCheckExclusion">
      <modal
        v-show="isPatternCheckExclusionModalVisible"
        @close="closePatternCheckExclusionModal"
        footer
      >
        <template v-slot:title>
          <h5>Transaction Pattern Checks</h5>
        </template>
        <template v-slot:body>
          <p class="text-muted">
            Temporarily skip duplicate-transaction and other pattern checks for
            this customer during restricted hours (8 PM–7 AM). Leave expiry
            blank for a permanent exception until manually restored.
          </p>
          <div class="form-group">
            <label>Exclude pattern checks</label>
            <select
              class="form-control"
              v-model="patternCheckExclusion.exclude_pattern_checks"
            >
              <option value="no">No — keep running pattern checks</option>
              <option value="yes">Yes — skip pattern checks</option>
            </select>
          </div>
          <div
            class="form-group"
            v-if="patternCheckExclusion.exclude_pattern_checks === 'yes'"
          >
            <label>Expires at (optional)</label>
            <input
              type="datetime-local"
              class="form-control"
              v-model="patternCheckExclusion.exclude_pattern_checks_until"
            />
            <small class="text-muted">
              Leave empty to keep the exception active until you turn it off.
            </small>
          </div>
          <div class="form-group">
            <label>Reason (optional)</label>
            <input
              type="text"
              class="form-control"
              v-model="patternCheckExclusionReason"
              placeholder="e.g. Legitimate recurring payments to same beneficiary"
            />
          </div>
        </template>
        <template v-slot:footer>
          <button type="submit" class="button">
            <span>Proceed</span>
          </button>
          <button
            type="button"
            class="btn btn-secondary"
            data-dismiss="modal"
            @click="closePatternCheckExclusionModal"
          >
            Cancel
          </button>
        </template>
      </modal>
    </form>

    <form @submit.prevent="promptSaveHoldExclusion">
      <modal
        v-if="selectedAccount !== null"
        v-show="isHoldExclusionModalVisible"
        @close="closeHoldExclusionModal"
        footer
      >
        <template v-slot:title>
          <h5>Transfer Hold Checks</h5>
        </template>
        <template v-slot:body>
          <p class="text-muted">
            Exclude this account from all transfer hold checks. Use this for
            trusted utility or operational accounts.
          </p>
          <div class="form-group">
            <label>Exclude hold checks</label>
            <select
              class="form-control"
              v-model="selectedAccount.exclude_transfer_holds"
            >
              <option value="no">No — keep running hold checks</option>
              <option value="yes">Yes — skip all hold checks</option>
            </select>
          </div>
          <div class="form-group">
            <label>Reason (optional)</label>
            <input
              type="text"
              class="form-control"
              v-model="holdExclusionReason"
              placeholder="e.g. Internal utility account"
            />
          </div>
        </template>
        <template v-slot:footer>
          <button type="submit" class="button">
            <span>Proceed</span>
          </button>
          <button
            type="button"
            class="btn btn-secondary"
            data-dismiss="modal"
            @click="closeHoldExclusionModal"
          >
            Cancel
          </button>
        </template>
      </modal>
    </form>
    
    <form @submit.prevent="updateEnterpriseAccess">
      <modal
        v-if="customerDetails !== null"
        v-show="isEnterpriseModalVisible"
        @close="closeEnterpriseModal"
        footer
      >
        <template v-slot:title>
          <h5>Update Enterprise Access</h5>
        </template>
        <template v-slot:body>
          <div class="form-group">
            <label for="type">Enterprise Access</label>
            <select
              name=""
              id=""
              class="form-control"
              v-model="customerDetails.is_enterprise_account"
            >
              <option value="" selected disabled>Please Select Access</option>
              <option value="no">NO</option>
              <option value="yes">YES</option>
              <option value="email">Email</option>
            </select>
          </div>
          <div class="form-group" v-if="customerDetails.is_enterprise_account === 'yes'">
            <label for="type">Virtual Account</label>
            <select
              name=""
              id=""
              class="form-control"
              v-model="customerDetails.is_enterprise_virtual_account"
            >
              <option value="" selected disabled>Please Select Access</option>
              <option value="no">NO</option>
              <option value="yes">YES</option>
              <option value="email">Email</option>
            </select>
          </div>        
        </template>
        <template v-slot:footer>
          <button
            type="submit"
            class="button"
          >
            <span v-if="sendMessageLoading">Please wait...</span>
            <span v-else>Update Access</span>
          </button>
          <button
            type="button"
            class="btn btn-secondary"
            data-dismiss="modal"
            @click="closeEnterpriseModal"
          >
            Cancel
          </button>
        </template>
      </modal>
    </form>

    <modal
        v-if="customerDetails !== null"
        v-show="isAiBlocksModalVisible"
        @close="closeAiBlocksModal"
        footer
      >
        <template v-slot:title>
          <h5>AI Blocks</h5>
        </template>
        <template v-slot:body>
          <button
            v-if="permissions.includes('verify-id-with-ai')"
            class="btn btn-success mt-2"
            @click="verifyIdWithAI()"
            :disabled="aiBtnLoading"
          >
            <span class="custom-loader" v-if="aiBtnLoading">
              <loader-icon
                size="1.5x"
                class="custom-class"
              ></loader-icon>
              <span style="font-weight: 600; text-transform: initial"
                >Please wait...</span
              >
            </span>
            <span v-else>
              Verify ID with AI
            </span>
          </button>
          <button
            v-if="permissions.includes('send-ai-kyc-reminder')"
            class="btn btn-success mt-2"
            @click="sendVoiceRemimder()"
            :disabled="voiceRemimderLoader"
          >
            <span class="custom-loader" v-if="voiceRemimderLoader">
              <loader-icon
                size="1.5x"
                class="custom-class"
              ></loader-icon>
              <span style="font-weight: 600; text-transform: initial"
                >Please wait...</span
              >
            </span>
            <span v-else>
              Send KYC Reminder
            </span>
          </button>
          <button
            v-if="permissions.includes('verify-id-with-ai')"
            class="btn btn-primary mt-2"
            :disabled="aiBtnLoading"
          >
            <span class="custom-loader" v-if="aiBtnLoading">
              <loader-icon
                size="1.5x"
                class="custom-class"
              ></loader-icon>
              <span style="font-weight: 600; text-transform: initial"
                >Please wait...</span
              >
            </span>
            <span v-else>
              Verify Utility Bill with AI
            </span>
          </button>
        </template>
        <template v-slot:footer>
          <button
            type="button"
            class="btn btn-secondary"
            data-dismiss="modal"
            @click="closeAiBlocksModal"
          >
            Cancel
          </button>
        </template>
      </modal>

    <form @submit.prevent="upgradeProcess">
      <modal
        v-show="isUpgradeAccountModalVisible"
        @close="closeUpgradeAccountModal"
        footer
      >
        <template v-slot:title>
          <h5>
            Upgrade Account
          </h5>
        </template>
        <template v-slot:body>
          <div class="form-group">
            <label for="status">KYC Level</label>
            <br />
            <select
              id="select"
              class="form-select fw-two form-control"
              v-model="kyc_level_id"
            >
              <option
                v-for="level in customerLevels"
                :value="level.id"
                :key="level.id"
              >
                {{ level.name }}</option
              >
            </select>
          </div>
        </template>
        <template v-slot:footer>
          <button
            type="submit"
            class="button"
            :disabled="upgradeAccountLoading"
          >
            <span class="custom-loader" v-if="upgradeAccountLoading">
              <loader-icon size="1.5x" class="custom-class"></loader-icon>
              <span style="font-weight: 600; text-transform: initial;"
                >Upgrading Account...</span
              >
            </span>
            <span v-else>Upgrade Account</span>
          </button>
          <button
            type="button"
            class="btn btn-secondary"
            data-dismiss="modal"
            @click="closeApproveDocModal"
          >
            Cancel
          </button>
        </template>
      </modal>
    </form>
    <form @submit.prevent="approveProcess">
      <modal
        v-show="isApproveDocModalVisible"
        @close="closeApproveDocModal"
        footer
      >
        <template v-slot:title>
          <h5>
            Approve Document For
            <span class>
              {{
                type === "utility_bill"
                  ? "Utility Bill"
                  : type === "id"
                  ? "ID"
                  : ""
              }}
            </span>
            file
          </h5>
        </template>
        <template v-slot:body>
          <div class="form-group">
            <label for="status">Document Type</label>
            <br />
            <select
              id="select"
              class="form-select fw-two form-control"
              v-model="type"
              disabled
            >
              <option value="id" class="mb-2">ID Card</option>
              <option value="utility_bill" class="mb-2">Utility Bill</option>
            </select>
          </div>
          <div class="form-group">
            <label for="status">Action</label>
            <br />
            <select
              id="select"
              class="form-select fw-two form-control"
              v-model="action"
            >
              <option value="approved" class="mb-2">Approved</option>
              <option value="rejected" class="mb-2">Rejected</option>
            </select>
          </div>
          <div class="form-group">
            <label for="status">Reason</label>
            <br />
            <textarea
              class="form-control"
              name="reason"
              id
              cols="30"
              rows="10"
              style="resize: none;"
              v-model="reason"
            ></textarea>
          </div>
        </template>
        <template v-slot:footer>
          <button
            type="submit"
            class="button"
            :disabled="approveDocLoading || !formIsValid"
          >
            <span class="custom-loader" v-if="approveDocLoading">
              <loader-icon size="1.5x" class="custom-class"></loader-icon>
              <span style="font-weight: 600; text-transform: initial;"
                >Approving Document...</span
              >
            </span>
            <span v-else>Approve Document</span>
          </button>
          <button
            type="button"
            class="btn btn-secondary"
            data-dismiss="modal"
            @click="closeApproveDocModal"
          >
            Cancel
          </button>
        </template>
      </modal>
    </form>
    <div
      v-if="getCustomerDetailsLoading || photoLoading"
      style="display: flex; top: 0px; position: fixed; left: 0px; right: 0px; bottom: 0px; background-color: rgba(247, 247, 247, 0.6); z-index: 9999; justify-content: center; align-items: center;"
    >
      <div>
        <div>
          <h3 v-if="getCustomerDetailsLoading">
            Getting Customer profile ready.....
          </h3>
          <h3 v-if="photoLoading">Loading.....</h3>
        </div>
      </div>
    </div>

    <div class="rider--main-content">
      <!-- <router-link
        :to="{ name: 'Customers' }"
        class="arrow_text cursor-pointer"
      >
        <chevron-left-icon
          size="1.5x"
          class="custom-class"
          style="vertical-align: top;"
        ></chevron-left-icon>
        <span class="back">Back</span>
      </router-link>-->
      <div @click="$router.go(-1)" class="arrow_text cursor-pointer">
        <chevron-left-icon
          size="1.5x"
          class="custom-class"
          style="vertical-align: top;"
        ></chevron-left-icon>
        <span class="back">Back</span>
      </div>

      <!-- Customer Account -->
      <h1 class="mt-2 mb-3 font-regular" v-if="customerDetails">
        {{ customerDetails.first_name }} {{ customerDetails.last_name }}'s
        Profile
      </h1>

      <div
        class="alert alert-danger"
        v-if="openTransferHolds.length"
      >
        <div class="d-flex justify-content-between align-items-center mb-2">
          <strong>Transfer holds are active on this customer.</strong>
          <div>
            <button
              v-if="permissions.includes('release-transfer-hold') && selectedHoldIds.length"
              class="btn btn-sm btn-warning mr-1"
              @click.prevent="promptBulkReleaseHolds"
            >
              Bulk Release
            </button>
            <button
              v-if="permissions.includes('clear-transfer-hold') && selectedHoldIds.length"
              class="btn btn-sm btn-danger mr-1"
              @click.prevent="promptBulkClearHolds"
            >
              Bulk Clear
            </button>
            <router-link
              v-if="permissions.includes('view-transfer-holds')"
              :to="{ name: 'TransferHolds' }"
              >View all holds</router-link
            >
          </div>
        </div>
        <p class="mb-2" v-if="transferAttemptCount">
          This customer has tried to transfer
          <strong>{{ transferAttemptCount }}</strong>
          time{{ transferAttemptCount === 1 ? "" : "s" }} while on hold.
        </p>
        <div class="table-responsive">
          <table class="table table-sm mb-0">
            <thead>
              <tr>
                <th>
                  <input
                    type="checkbox"
                    :checked="allOpenHoldsSelected"
                    @change="toggleSelectAllHolds($event.target.checked)"
                  />
                </th>
                <th>Reason</th>
                <th>Reference</th>
                <th>Status</th>
                <th>Attempts</th>
                <th>Released until</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="hold in openTransferHolds" :key="hold.id">
                <td>
                  <input
                    type="checkbox"
                    :checked="selectedHoldIds.includes(hold.id)"
                    @change="toggleHoldSelection(hold.id, $event.target.checked)"
                  />
                </td>
                <td>{{ hold.reason_label || hold.reason }}</td>
                <td>{{ hold.reference_key || "—" }}</td>
                <td>{{ hold.status }}</td>
                <td>{{ hold.blocked_attempts || 0 }}</td>
                <td>{{ hold.released_until || "—" }}</td>
                <td>
                  <button
                    v-if="permissions.includes('release-transfer-hold')"
                    class="btn btn-sm btn-warning mr-1"
                    @click.prevent="promptReleaseHold(hold)"
                  >
                    Release
                  </button>
                  <button
                    v-if="permissions.includes('clear-transfer-hold')"
                    class="btn btn-sm btn-danger"
                    @click.prevent="promptClearHold(hold)"
                  >
                    Clear
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div
        class="alert alert-info"
        v-if="excludedHoldAccounts.length"
      >
        Transfer hold checks are excluded on
        <strong>{{ excludedHoldAccounts.map(account => account.account_number).join(", ") }}</strong>.
        New holds will not be placed, and existing holds will not block transfers.
      </div>

      <div class="row">
        <div class="col-xl-4 col-lg-6 col-12 px--5">
          <CCard
            :bgColor="'#7987A1'"
            :text="'Bill Payment'"
            :currency="true"
            :value="customerStats.bills_payment"
          />
        </div>
        <div class="col-xl-4 col-lg-6 col-12 px--5">
          <CCard
            :bgColor="'#FBC108'"
            :text="'Inter Bank Transfer'"
            :currency="true"
            :value="customerStats.inter_bank_transfers"
          />
        </div>
        <div class="col-xl-4 col-lg-6 col-12 px--5">
          <CCard
            :bgColor="'#2CB858'"
            :text="'Intra Bank Transfer'"
            :currency="true"
            :value="customerStats.intra_bank_transfers"
          />
        </div>
      </div>

      <div class="row mb-5">
        <div class="col-lg-12">
          <CScrollbar
            class="nav nav-tabs nav-overflow header-tabs"
            :settings="psSettings"
            tag="ul"
          >
            <li class="nav-item">
              <a
                class="nav-link"
                href="javascript:void(0)"
                v-on:click="activetab = 1"
                v-bind:class="[activetab === 1 ? 'active' : '']"
                >Customer Profile</a
              >
            </li>
            <li class="nav-item">
              <a
                class="nav-link"
                href="javascript:void(0)"
                v-on:click="activetab = 7"
                v-bind:class="[activetab === 7 ? 'active' : '']"
                >Documents</a
              >
            </li>
            <li class="nav-item" v-if="permissions.includes('cards')">
              <a
                class="nav-link"
                href="javascript:void(0)"
                v-on:click="activetab = 2"
                v-bind:class="[activetab === 2 ? 'active' : '']"
                >Cards</a
              >
            </li>
            <li class="nav-item" v-if="permissions.includes('payments')">
              <a
                class="nav-link"
                href="javascript:void(0)"
                v-on:click="activetab = 3"
                v-bind:class="[activetab === 3 ? 'active' : '']"
                >Transactions</a
              >
            </li>
            <li class="nav-item" v-if="permissions.includes('payments')">
              <a
                class="nav-link"
                href="javascript:void(0)"
                v-on:click="activetab = 10"
                v-bind:class="[activetab === 10 ? 'active' : '']"
                >Statement</a
              >
            </li>
            <li class="nav-item">
              <a
                class="nav-link"
                href="javascript:void(0)"
                v-on:click="activetab = 4"
                v-bind:class="[activetab === 4 ? 'active' : '']"
                >Account Details</a
              >
            </li>
            <li
              class="nav-item"
              v-if="
                permissions.includes('terminals') && customerDetails !== null
              "
            >
              <a
                v-if="customerDetails.terminals.length > 0"
                class="nav-link"
                href="javascript:void(0)"
                v-on:click="activetab = 9"
                v-bind:class="[activetab === 9 ? 'active' : '']"
                >Customer Terminals</a
              >
            </li>
            <li
              class="nav-item"
              v-if="
                permissions.includes('instant-loans') &&
                  customerDetails !== null
              "
            >
              <a
                class="nav-link"
                href="javascript:void(0)"
                v-on:click="activetab = 12"
                v-bind:class="[activetab === 12 ? 'active' : '']"
                >Instant Loan</a
              >
            </li>
            <li
              class="nav-item"
              v-if="
                permissions.includes('documents') &&
                  customerDetails !== null
              "
            >
              <a
                class="nav-link"
                href="javascript:void(0)"
                v-on:click="activetab = 13"
                v-bind:class="[activetab === 13 ? 'active' : '']"
                >Compliance Documents</a
              >
            </li>
            <li
              class="nav-item"
              v-if="
                permissions.includes('change-request') &&
                  customerDetails !== null
              "
            >
              <a
                class="nav-link"
                href="javascript:void(0)"
                v-on:click="activetab = 8"
                v-bind:class="[activetab === 8 ? 'active' : '']"
                >change Request</a
              >
            </li>
            
            <!--   <li class="nav-item">
              <a
                class="nav-link"
                href="javascript:void(0)"
                v-on:click="activetab = 5"
                v-bind:class="[activetab === 5 ? 'active' : '']"
              >
                Property Savings
              </a>
            </li>
            <li class="nav-item">
              <a
                class="nav-link"
                href="javascript:void(0)"
                v-on:click="activetab = 6"
                v-bind:class="[activetab === 6 ? 'active' : '']"
              >
                Target Savings
              </a>
            </li>-->
          </CScrollbar>
        </div>
      </div>
      <div v-if="customerDetails !== null && activetab === 10">
        <div class="row">
          <div class="col-md-3 mt-1 mt-md-0">
            <input type="date" v-model="start_date" class="form-control" />
          </div>
          <div class="col-md-3 mt-1  mt-md-0">
            <input type="date" v-model="stop_date" class="form-control" />
          </div>
          <div class="col-md-3 mt-1 mt-md-0">
            <select
              name="account"
              id=""
              class="form-control"
              v-model="acc_number"
            >
              <option value="">Select Account</option>
              <option
                :value="item.account_number"
                v-for="(item, index) in customerDetails.accounts"
                :key="index"
                >{{ item.account_number }}</option
              >
            </select>
          </div>
          <div class=" col-auto">
            <button
              class="btn btn-primary"
              @click.prevent="getStatement"
              :disabled="!statementFormIsValid || statement_loading"
            >
              Search
            </button>
          </div>
        </div>

        <BankStatement :statement="statement" />
      </div>
      <div v-if="activetab === 8 && customerDetails && permissions.includes('change-request')">
  <ChangeRequestComponent :customer_user_id="changeRequestCustomerId || customerDetails.id" :onRefresh="getCustomerDetails" />
      </div>
      <!-- documents -->
      <div class="row" v-if="activetab === 7">
        <div class="col-12" v-if="customerDetails">
          <div class="card card--no-shadow card-profile">
            <div class="card-content">
              <div class="card-body">
                <div class="row">
                  <div class="images" v-viewer>
                    <!-- <img
                      v-for="(src, index) in images"
                      :key="index"
                      :src="src"
                    /> -->
                    <!-- <img :src="imageModalQuery" alt="" /> -->
                  </div>

                  <div class="col-md-4" v-if="bvn_image !== ''">
                    <magnifier title="BVN Image" :imageSrc="bvn_image" />
                  </div>
                  <div class="col-md-4">
                    <div class="card">
                      <div class="card-content">
                        <div class="card-body">
                          <h3>Id File</h3>
                          <div
                            style="cursor: pointer"
                            class="id-file"
                            @click.prevent="
                              openImageModal(customerDetails.kyc.identity_file)
                            "
                          >
                            <img
                              style="cursor: pointer"
                              class="h-100 w-100 img-fluid"
                              :src="customerDetails.kyc.identity_file"
                              alt="id file"
                            />
                          </div>

                          <h4 class="mt-2">
                            <span class="fw-bold">Status:</span>
                            {{ customerDetails.kyc.identity_status }}
                          </h4>
                          <h2 class="mt-1">
                            <span class="fw-bold">Message:</span>
                            {{ customerDetails.kyc.identity_status_message }}
                          </h2>
                          
                          <h4 class="mt-1" v-if="customerDetails.kyc.id_ai_status">
                            <span class="fw-bold">AI status:</span>
                            {{ customerDetails.kyc.id_ai_status }}
                          </h4>
                          <h4 class="mt-1" v-if="customerDetails.kyc.id_ai_description">
                            <span class="fw-bold">AI Response:</span>
                            {{ customerDetails.kyc.id_ai_description }}
                          </h4>
                          <button
                            v-if="permissions.includes('treat-customer-kyc')"
                            class="btn btn-primary mt-2"
                            @click="showApproveDocModal('id')"
                          >
                            Approve ID File
                          </button>                         
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="card">
                      <div class="card-content">
                        <div class="card-body">
                          <h3>Utility File</h3>
                          <div
                            style="cursor: pointer"
                            class="id-file"
                            @click.prevent="
                              openImageModal(
                                customerDetails.kyc.utility_bill_file
                              )
                            "
                          >
                            <img
                              style="cursor: pointer"
                              class="h-100 w-100 img-fluid"
                              :src="customerDetails.kyc.utility_bill_file"
                              alt="id file"
                            />
                          </div>

                          <h4 class="mt-2">
                            <span class="fw-bold">Status:</span>
                            {{ customerDetails.kyc.utility_bill_status }}
                          </h4>
                          <h2 class="mt-1">
                            <span class="fw-bold">Message:</span>
                            {{
                              customerDetails.kyc.utility_bill_status_message
                            }}
                          </h2>
                          <h4 class="mt-1" v-if="customerDetails.kyc.bill_ai_status">
                            <span class="fw-bold">AI status:</span>
                            {{ customerDetails.kyc.bill_ai_status }}
                          </h4>
                          <h4 class="mt-1" v-if="customerDetails.kyc.bill_ai_description">
                            <span class="fw-bold">AI Response:</span>
                            {{ customerDetails.kyc.bill_ai_description }}
                          </h4>
                          <h4 v-if="photoLoading">Loading...</h4>
                          <button
                            v-if="permissions.includes('treat-customer-kyc')"
                            class="btn btn-primary mt-2"
                            @click="showApproveDocModal('utility_bill')"
                          >
                            Treat Utility File
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- customer profile -->
      <div class="row" v-if="activetab === 1">
        <div class="col-md-4" v-if="customerDetails">
          <div class="card card--no-shadow card-profile">
            <div class="card-content">
              <div class="card-body position-relative d-flex flex-column">
                <div class="mx-auto position-relative text-center">
                  <img
                    :src="customerDetails.avatar"
                    alt=""
                    class="img-fluid"
                    style="width: 50%; height: 50%; cursor: pointer"
                    @click.prevent="openImageModal(customerDetails.avatar)"
                  />
                  <div class="mt-2 card--profile-name ">
                    <h5>
                      Customer Level : {{ customerDetails.kyc.kyc_level.name }}
                    </h5>
                    <hr />
                    <button
                      v-if="permissions.includes('update-customer-info-on-cba')"
                      class="btn btn-info mt-2 px-2"
                      @click="updateCustomerToCBA"
                    >
                      <span class="custom-loader" v-if="pushCbaLoading">
                        <loader-icon
                          size="1.5x"
                          class="custom-class"
                        ></loader-icon>
                        <span style="font-weight: 600; text-transform: initial"
                          >Please wait...</span
                        >
                      </span>
                      <span v-else>
                        Push Customer Photo to Cba
                      </span>
                    </button>
                    <button
                      v-if="permissions.includes('update-customer-info-on-cba')"
                      class="btn btn-info mt-2 px-2"
                      @click="updateCustomerIDToCBA"
                    >
                      <span class="custom-loader" v-if="pushCbaLoading">
                        <loader-icon
                          size="1.5x"
                          class="custom-class"
                        ></loader-icon>
                        <span style="font-weight: 600; text-transform: initial"
                          >Please wait...</span
                        >
                      </span>
                      <span v-else>
                        Push Customer ID to CBA
                      </span>
                    </button>
                    <button
                      v-if="permissions.includes('upgrade-customer-level')"
                      class="btn btn-primary mt-2"
                      @click="openUpgradeAccountModal()"
                    >
                      Upgrade Account
                    </button>
                    <button
                      v-if="permissions.includes('manage-kyc-limit-overrides')"
                      class="btn btn-outline-primary mt-2"
                      @click="openKycLimitOverrideModal()"
                    >
                      Temporary Limit Override
                    </button>
                    <div
                      v-if="canViewKycLimitOverrides && kycLimitOverrides.length"
                      class="text-left mt-3"
                    >
                      <h6 class="mb-2">Active limit overrides</h6>
                      <div
                        v-for="item in kycLimitOverrides"
                        :key="item.id"
                        class="d-flex justify-content-between align-items-start mb-2"
                      >
                        <div>
                          <div class="font-weight-bold">{{ item.label }}</div>
                          <div>₦{{ Number(item.override_value).toLocaleString() }} until {{ item.expires_at }}</div>
                          <small class="text-muted" v-if="item.reason">{{ item.reason }}</small>
                        </div>
                        <button
                          v-if="permissions.includes('manage-kyc-limit-overrides')"
                          type="button"
                          class="btn btn-sm btn-outline-danger"
                          @click="promptDeleteKycLimitOverride(item)"
                        >
                          Remove
                        </button>
                      </div>
                    </div>
                    <button
                      v-if="permissions.includes('send-message-to-customer')"
                      class="btn btn-info mt-2 px-2"
                      @click="openSendMessageModal"
                    >
                      Send Message to Customer
                    </button>
                    <div class=" d-flex justify-content-evenly">
                      <button
                        v-if="permissions.includes('reset-password-directly')"
                        class="mt-2 btn d-block btn-info"
                        @click="resetPassword('password')"
                        :disabled="rpLoading && resetType === 'password'"
                      >
                        <span
                          class="custom-loader"
                          v-if="rpLoading && resetType === 'password'"
                        >
                          <loader-icon
                            size="1.5x"
                            class="custom-class"
                          ></loader-icon>
                          <span
                            style="font-weight: 600; text-transform: initial"
                            >Please wait...</span
                          >
                        </span>
                        <span v-else>
                          Reset Password
                        </span>
                      </button>

                      <verify-identity
                        v-if="
                          customerDetails.phone_number !== null &&
                            customerDetails.phone_number !== ''
                        "
                        identityName="Phone Number"
                        identityType="phone"
                        :identifier="customerDetails.phone_number"
                      />
                      <button
                        v-if="permissions.includes('reset-pin-directly')"
                        class="btn btn-amber mt-2 d-block"
                        @click="resetPassword('pin')"
                        :disabled="rpLoading && resetType === 'pin'"
                      >
                        <span
                          class="custom-loader"
                          v-if="rpLoading && resetType === 'pin'"
                        >
                          <loader-icon
                            size="1.5x"
                            class="custom-class"
                          ></loader-icon>
                          <span
                            style="font-weight: 600; text-transform: initial"
                            >Please wait...</span
                          >
                        </span>
                        <span v-else>
                          Reset Pin
                        </span>
                      </button>
                      <button
                        v-if="
                          permissions.includes('reset-customer-fa') &&
                            customerDetails.is_2fa_enabled == 1
                        "
                        class="btn btn-warning mt-2 d-block"
                        @click="resetCustomer2FA()"
                        :disabled="reset2faLoading"
                      >
                        <span class="custom-loader" v-if="reset2faLoading">
                          <loader-icon
                            size="1.5x"
                            class="custom-class"
                          ></loader-icon>
                          <span
                            style="font-weight: 600; text-transform: initial"
                            >Please wait...</span
                          >
                        </span>
                        <span v-else>
                          Reset 2FA
                        </span>
                      </button>
                    </div>
                    <button
                      v-if="permissions.includes('reset-pin-directly')"
                      class="btn btn-amber mt-2 px-2"
                      @click="showAddAccountToCustomerModal('preview')"
                      :disabled="rpLoading"
                    >
                      <span>
                        Add Account to Customer
                      </span>
                    </button>
                    <button
                      v-if="permissions.includes('reset-pin-directly')"
                      class="btn btn-info mt-2 px-2"
                      @click="openEnterpriseModal"                      
                    >
                      <span>
                        Enterprise Access
                      </span>
                    </button>
                    <button
                      v-if="permissions.includes('ai-block')"
                      class="btn btn-info btn-block mt-2 px-2"
                      @click="showAiBlocksModal"                      
                    >
                      <span>
                        AI Block
                      </span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-8" v-if="customerDetails !== null">
          <!-- General Information -->
          <div class="card card--no-shadow card-profile">
            <div class="card-header">
              <h3 class="font-weight-600 mb-0">Profile Information</h3>
            </div>
            <div class="card-content">
              <div class="card-body">
                <form @submit.prevent="updateCustomerProfile">
                  <!-- General Information -->
                  <div class="actions-toolbar pb-2">
                    <h5 class="actions-title">General Information</h5>
                  </div>
                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="full_name">First Name</label>
                        <input
                          type="text"
                          class="form-control"
                          v-model.trim="customerDetails.first_name"
                          placeholder="Full Name"
                          name="firstname"
                          disabled
                        />
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="last_name">Last Name</label>
                        <input
                          type="text"
                          class="form-control"
                          v-model.trim="customerDetails.last_name"
                          placeholder="Full Name"
                          name="lastname"
                          disabled
                        />
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="email_address">Email Address</label>
                        <input
                          type="email"
                          id="email_address"
                          class="form-control"
                          v-model.trim="customerDetails.email"
                          placeholder="Email Address"
                          name="email_address"
                          disabled
                        />
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="bvn">BVN</label>
                        <input
                          type="text"
                          class="form-control"
                          v-model.trim="customerDetails.kyc.bvn"
                          placeholder="bvn"
                          name="bvn"
                          disabled
                        />
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="phone_number">Phone Number</label>
                        <input
                          type="text"
                          class="form-control"
                          v-model.trim="customerDetails.phone_number"
                          placeholder="Phone Number"
                          disabled
                        />
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="status">Gender</label>
                        <br />
                        <input
                          type="text"
                          class="form-control"
                          v-model.trim="customerDetails.gender"
                          placeholder="Gender"
                          disabled
                        />
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="status">Date of Birth</label>
                        <br />
                        <input
                          type="text"
                          class="form-control"
                          v-model.trim="customerDetails.date_of_birth"
                          placeholder="Gender"
                          disabled
                        />
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="status">Status</label>
                        <br />
                        <select
                          id="select"
                          :disabled="
                            !permissions.includes('update-customer-full-info')
                          "
                          class="form-select fw-two form-control"
                          v-model="customerDetails.profile_status"
                        >
                          <option
                            value="active"
                            class="mb-2"
                            :selected="
                              customerDetails.profile_status == 'active'
                            "
                            >Active</option
                          >
                          <option
                            value="suspended"
                            class="mb-2"
                            :selected="
                              customerDetails.profile_status == 'suspended'
                            "
                            >Suspended</option
                          >

                          <option
                            value="blocked"
                            class="mb-2"
                            :selected="
                              customerDetails.profile_status == 'blocked'
                            "
                            >Blocked</option
                          >
                        </select>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="status">Marketer Status</label>
                        <br />
                        <select
                          id="select"
                          :disabled="
                            !permissions.includes('update-customer-full-info')
                          "
                          class="form-select fw-two form-control"
                          v-model="customerDetails.is_marketer"
                        >
                          <option
                            value="yes"
                            class="mb-2"
                            :selected="customerDetails.is_marketer == 'yes'"
                            >Yes</option
                          >
                          <option
                            value="no"
                            class="mb-2"
                            :selected="customerDetails.is_marketer == 'no'"
                            >No</option
                          >
                        </select>
                      </div>
                    </div>
                    <div class="col-md-6" v-if="customerDetails.loan_profile">
                      <div class="form-group">
                        <label for="status">Loan Type</label>
                        <br />
                        <select
                          id="select"
                          :disabled="
                            !permissions.includes('update-customer-full-info')
                          "
                          class="form-select fw-two form-control"
                          v-model="customerDetails.loan_profile.loan_type"
                        >
                          <option
                            value="nano"
                            class="mb-2"
                            :selected="
                              customerDetails.loan_profile.loan_type == 'nano'
                            "
                            >Nano</option
                          >
                          <option
                            value="sme"
                            class="mb-2"
                            :selected="
                              customerDetails.loan_profile.loan_type == 'sme'
                            "
                            >SME</option
                          >
                        </select>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="status">Referral Code</label>
                        <br />
                        <input
                          type="text"
                          class="form-control"
                          v-model.trim="customerDetails.referral_code"
                          placeholder="Referral Code"
                          name="referral_code"
                          :disabled="
                            !permissions.includes('update-customer-full-info')
                          "
                        />
                      </div>
                    </div>
                  </div>

                  <div class="row" v-if="customerDetails.referred_by_details">
                    <div
                      class="col-md-6"
                      v-if="customerDetails.referred_by_details.user_id != 1"
                    >
                      <div class="form-group">
                        <label for="status">Referred BY</label>
                        <br />
                        {{
                          customerDetails.referred_by_details.user.first_name
                        }}
                        {{ customerDetails.referred_by_details.user.last_name }}
                        <br />
                        <router-link
                          class="button"
                          :to="{
                            name: 'CustomerComponent',
                            params: {
                              slug: customerDetails.referred_by_details.user.id
                            }
                          }"
                          target="_blank"
                        >
                          View Customer
                        </router-link>
                      </div>
                    </div>
                  </div>
                  <!-- Address Details -->
                  <div class="actions-toolbar py-2">
                    <h5 class="actions-title">Address Details</h5>
                  </div>
                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="state">State</label>
                        <select
                          name="state"
                          v-model="customerDetails.kyc.state_id"
                          class="form-control"
                          @change="changeStates()"
                          :disabled="
                            !permissions.includes('update-customer-full-info')
                          "
                        >
                          <option value selected disabled>Select state</option>
                          <option
                            :value="state.id"
                            v-for="state in states"
                            :key="state.id"
                            >{{ state.name }}</option
                          >
                        </select>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="city">City</label>
                        <input
                          type="text"
                          class="form-control"
                          v-model.trim="customerDetails.kyc.city"
                          placeholder="City"
                          :disabled="
                            !permissions.includes('update-customer-full-info')
                          "
                          name="city"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label for="address">Address</label>
                        <input
                          type="text"
                          class="form-control"
                          v-model.trim="customerDetails.kyc.address"
                          placeholder="Address"
                          name="address"
                          :disabled="
                            !permissions.includes('update-customer-full-info')
                          "
                        />
                      </div>
                    </div>
                  </div>

                  <!-- next of kin -->
                  <div class="actions-toolbar py-2">
                    <h5 class="actions-title">Next Of Kin</h5>
                  </div>

                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="address">First Name</label>
                        <input
                          type="text"
                          class="form-control"
                          v-model.trim="customerDetails.kyc.nok_firstname"
                          placeholder="Address"
                          name="address"
                          disabled
                        />
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="address">Last Name</label>
                        <input
                          type="text"
                          class="form-control"
                          v-model.trim="customerDetails.kyc.nok_lastname"
                          placeholder="Address"
                          name="address"
                          disabled
                        />
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="address">Email</label>
                        <input
                          type="text"
                          class="form-control"
                          v-model.trim="customerDetails.kyc.nok_email"
                          placeholder="Address"
                          name="address"
                          disabled
                        />
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="address">Relationship</label>
                        <input
                          type="text"
                          class="form-control"
                          v-model.trim="customerDetails.kyc.nok_relationship"
                          placeholder="Address"
                          name="address"
                          disabled
                        />
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="address">Phone Number</label>
                        <input
                          type="text"
                          class="form-control"
                          v-model.trim="customerDetails.kyc.nok_phone_number"
                          placeholder="Address"
                          name="address"
                          disabled
                        />
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label for="address">Address</label>
                        <input
                          type="text"
                          class="form-control"
                          v-model.trim="customerDetails.kyc.nok_full_ddress"
                          placeholder="Address"
                          name="address"
                          disabled
                        />
                      </div>
                    </div>
                  </div>

                  <button
                    v-if="permissions.includes('update-customer-full-info')"
                    type="submit"
                    class="button"
                    :disabled="
                      updateCustomerLoading ||
                        !permissions.includes('update-customer-full-info')
                    "
                    :class="
                      permissions.includes('update-customer-full-info')
                        ? ''
                        : 'disabled cursor-not-allowed'
                    "
                  >
                    <span class="custom-loader" v-if="updateCustomerLoading">
                      <loader-icon
                        size="1.5x"
                        class="custom-class"
                      ></loader-icon>
                      <span style="font-weight: 600; text-transform: initial;"
                        >Updating Customer...</span
                      >
                    </span>
                    <span v-else>Save Changes</span>
                  </button>
                </form>
              </div>
            </div>
          </div>

          <hr />

          <!-- Delete Account -->
          <!-- <div>
            <div class="page-inner-header mb-2">
              <h5 class="mb-1 font-weight-600">Delete account</h5>
              <p class="text-muted mb-0">
                Once you delete this account, there is no going back. Please be
                certain.
              </p>
            </div>
            <div class="row">
              <div class="col-md-8">
                <button
                  type="button"
                  class="btn btn-danger"
                  @click="showModal"
                  data-toggle="modal"
                  data-target="#modal_account_deactivate"
                >
                  Delete this account
                </button>
              </div>
            </div>
          </div>-->
        </div>
      </div>

      <!-- customer card -->
      <div class="row" v-if="activetab === 2 && permissions.includes('cards')">
        <div class="col-md-12" v-if="customerDetails !== null">
          <!-- <button class="btn btn-primary w-auto mb-1">
            Create Card Request
          </button> -->

          <div class="card">
            <div class="card-content">
              <div class="card-body">
                <CDataTable
                  :items="customerCards"
                  :fields="card_fields"
                  :items-per-page="small ? 10 : 5"
                  pagination
                  sorter
                  tableFilter
                >
                  <template #email="{ item }">
                    <td class="table--action-mobile">{{ item.c_email }}</td>
                  </template>
                  <template #last_four="{ item }">
                    <td class="table--action-mobile">
                      {{ item.c_last_four_digit }}
                    </td>
                  </template>
                  <template #mask_pan="{ item }">
                    <td class="table--action-mobile">{{ item.c_mask_pan }}</td>
                  </template>
                  <template #provider="{ item }">
                    <td class="table--action-mobile">{{ item.c_provider }}</td>
                  </template>
                  <template #card_type="{ item }">
                    <td class="table--action-mobile">{{ item.c_type }}</td>
                  </template>
                  <template #created_at="{ item }">
                    <td class="table--action-mobile">
                      {{ item.created_at | date }}
                    </td>
                  </template>
                </CDataTable>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="row"
        v-if="activetab === 3 && permissions.includes('payments')"
      >
        <div class="col-md-12" v-if="customerDetails !== null">
          <div class="card">
            <div class="card-content">
              <div class="card-body">
                <CDataTable
                  :items="payments"
                  :fields="fields"
                  :items-per-page="small"
                  sorter
                >
                  <!-- <template #created_at="{item}">
                <td class="table--action-mobile">
                  {{ item.created_at | date }}
                </td>
              </template> -->
                  <template #actions="{ item }">
                    <!-- <td>{{ item.created_at | date }}</td> -->
                    <td
                      class="table--action-mobile"
                      v-if="permissions.includes('view-payment')"
                    >
                      <router-link
                        class="button"
                        :to="{
                          name: 'Payment',
                          params: { slug: item.transaction_reference }
                        }"
                        >View Transaction</router-link
                      >
                    </td>
                  </template>
                </CDataTable>
                <CPagination
                  :activePage.sync="next_page"
                  :pages="total"
                  :onActivePageChange="onPageChange()"
                >
                </CPagination>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- aacount details -->
      <div class="row" v-if="activetab === 4 && customerDetails !== null">
        <div class="col-md-12 mb-3">
          <div class="card shadow-sm">
            <div class="card-body">
              <div class="row align-items-center justify-content-between">
                <div class="col-md-8">
                  <h5 class="text-blue fw-bold mb-1">Pattern Checks</h5>
                  <p class="text-muted mb-2">
                    Controls duplicate-transaction and related fraud pattern
                    checks during restricted hours.
                  </p>
                  <h6 class="text-blue fw-bold mb-1">
                    Status:
                    <span
                      :class="
                        patternChecksExcludedActive
                          ? 'text-success'
                          : 'text-warning'
                      "
                    >
                      {{
                        patternChecksExcludedActive
                          ? "Excluded"
                          : "Enabled"
                      }}
                    </span>
                  </h6>
                  <p
                    class="text-muted mb-0"
                    v-if="patternChecksExcludedActive && customerDetails.exclude_pattern_checks_until"
                  >
                    Expires:
                    {{ customerDetails.exclude_pattern_checks_until | date }}
                  </p>
                  <p
                    class="text-muted mb-0"
                    v-if="customerDetails.exclude_pattern_checks_reason"
                  >
                    Reason: {{ customerDetails.exclude_pattern_checks_reason }}
                  </p>
                </div>
                <div class="col-md-4 text-md-right">
                  <button
                    v-if="permissions.includes('manage-pattern-check-exclusions')"
                    class="btn btn-outline-primary btn-min-width"
                    @click="openPatternCheckExclusionModal"
                  >
                    Pattern Check Setting
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="mt-2 card--profile-name col-md-6"
          v-for="(account, index) in customerDetails.accounts"
          :key="index"
        >
          <div class="card shadow-lg">
            <div class="card-body">
              <div class="row align-items-center justify-content-between">
                <div class="col-auto">
                  <h5 class="text-blue fw-700 fw-bolder">NUBAN:</h5>
                </div>
                <div class="col-auto">
                  <h6 class="text-blue fw-bold">
                    {{ account.account_number }}
                  </h6>
                </div>
              </div>
              <div class="row align-items-center justify-content-between">
                <div class="col-auto">
                  <h5 class="text-blue fw-700 fw-bolder">Account Name:</h5>
                </div>
                <div class="col-auto">
                  <h6 class="text-blue fw-bold">
                    {{ account.account_name }}
                  </h6>
                </div>
              </div>
              <div class="row align-items-center justify-content-between">
                <div class="col-auto">
                  <h5 class="text-blue fw-700 fw-bolder">Account Type:</h5>
                </div>
                <div class="col-auto">
                  <h6 class="text-blue fw-bold">
                    {{ account.account_type }}
                  </h6>
                </div>
              </div>
              <div class="row align-items-center justify-content-between">
                <div class="col-auto">
                  <h5 class="text-blue fw-700 fw-bolder">Account Level:</h5>
                </div>
                <div class="col-auto">
                  <h6 class="text-blue fw-bold">
                    {{ customerDetails.kyc.kyc_level.name }}
                  </h6>
                </div>
              </div>
              <div class="row align-items-center justify-content-between">
                <div class="col-auto">
                  <h5 class="text-blue fw-700 fw-bolder">Account Category:</h5>
                </div>
                <div class="col-auto">
                  <h6 class="text-blue fw-bold">
                    {{
                      account.account_category
                        ? account.account_category
                        : "Individual"
                    }}
                  </h6>
                </div>
              </div>
              <div class="row align-items-center justify-content-between">
                <div class="col-auto">
                  <h5 class="text-blue fw-700 fw-bolder">Hold Checks:</h5>
                </div>
                <div class="col-auto">
                  <h6 class="text-blue fw-bold">
                    {{
                      account.exclude_transfer_holds === "yes"
                        ? "Excluded"
                        : "Enabled"
                    }}
                  </h6>
                </div>
              </div>
              <div class="row align-items-center justify-content-between">
                <div class="col-auto">
                  <h5 class="text-blue fw-700 fw-bolder">App Listing:</h5>
                </div>
                <div class="col-auto">
                  <h6
                    class="fw-bold"
                    :class="
                      account.account_status === 'removed'
                        ? 'text-danger'
                        : 'text-success'
                    "
                  >
                    {{
                      account.account_status === "removed"
                        ? "Removed"
                        : "Visible"
                    }}
                  </h6>
                </div>
              </div>
              <div class="row align-items-center justify-content-end mt-1">
                <button
                  v-if="permissions.includes('view-account-balance')"
                  :disabled="!permissions.includes('view-account-balance')"
                  class="col-auto btn-sm btn-primary btn-min-width mr-1"
                  @click="revealBalance(account.account_number)"
                >
                  <span class="custom-loader" v-if="accountLoading">
                    <loader-icon size="1.5x" class="custom-class"></loader-icon>
                    <span style="font-weight: 600; text-transform: initial;"
                      >Please Wait</span
                    >
                  </span>
                  <span v-else>Get Balance</span>
                </button>

                <button
                  v-if="permissions.includes('view-account-balance') && customerDetails.is_enterprise_virtual_account === 'yes'"
                  class="col-auto btn-sm btn-primary btn-min-width"
                  @click="openVirtualAccountModal(account)"
                >
                  Virtual Account Setting
                </button>
                <button
                  v-if="permissions.includes('clear-transfer-hold')"
                  class="col-auto btn-sm btn-outline-primary btn-min-width ml-1"
                  @click="openHoldExclusionModal(account)"
                >
                  Hold Check Setting
                </button>
                <button
                  v-if="
                    permissions.includes('remove-account') &&
                      account.account_status !== 'removed'
                  "
                  class="col-auto btn-sm btn-outline-danger btn-min-width ml-1"
                  @click="promptUpdateAccountAppVisibility(account, 'removed')"
                >
                  Remove from App
                </button>
                <button
                  v-if="
                    permissions.includes('remove-account') &&
                      account.account_status === 'removed'
                  "
                  class="col-auto btn-sm btn-outline-success btn-min-width ml-1"
                  @click="promptUpdateAccountAppVisibility(account, 'active')"
                >
                  Restore to App
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="activetab === 9 && permissions.includes('terminals')">
        <!-- temrinals -->
        <div class="card">
          <div class="card-content">
            <div class="card-body">
              <CDataTable
                :items="customerDetails.terminals"
                :fields="tFields"
                :items-per-page="small ? 10 : 5"
                pagination
                sorter
                tableFilter
              >
                <!-- <template #name="{item}">
                  <td>
                    {{ item.user.first_name + " " + item.user.last_name }}
                  </td>
                </template> -->
                <template #updated_at="{ item }">
                  <td class="table--action-mobile">
                    {{ item.updated_at | date }}
                  </td>
                </template>
                <template #action="{ item }">
                  <td
                    class="table--action-mobile"
                    v-if="permissions.includes('view-terminal')"
                  >
                    <router-link
                      class="button btn-primary"
                      :to="{
                        name: 'ViewTerminal',
                        params: { slug: item.terminalID }
                      }"
                    >
                      View
                    </router-link>
                  </td>
                </template>
              </CDataTable>
              <!-- <CPagination
                :activePage.sync="next_page"
                :pages="total"
                :onActivePageChange="onPageChange()"
              ></CPagination> -->
            </div>
          </div>
        </div>
      </div>

      <div v-if="activetab === 12 && permissions.includes('instant-loans')">
        <!-- temrinals -->
        <div class="card">
          <div class="card-content">
            <div class="card-body">
              <CDataTable :items="loanProducts" :fields="loan_fields" sorter>
                <template #name="{ item }">
                  <td>
                    {{ `${item.user.first_name} ${item.user.last_name}` }}
                  </td>
                </template>

                <template #phone="{ item }">
                  <td>
                    {{ item.user.phone_number }}
                  </td>
                </template>
                <template #bvn="{ item }">
                  <td>
                    {{ item.user.kyc.bvn }}
                  </td>
                </template>
                <template #created_at="{ item }">
                  <td>
                    {{ item.created_at | date }}
                    <!-- {{
                      item.created_at === null
                        ? ""
                        : `${item.created_at | date}`
                    }} -->
                  </td>
                </template>
                <template #due_date="{ item }">
                  <td>
                    {{ item.due_date | date }}
                  </td>
                </template>
                <template #disbursed_date="{ item }">
                  <td>
                    {{ item.disbursed_date | date }}
                  </td>
                </template>
                <template #action="{ item }">
                  <td>
                    <router-link
                      v-if="permissions.includes('view-instant-loan')"
                      :to="{
                        name: 'LoanComponent',
                        params: { slug: item.instant_reference }
                      }"
                      class="button"
                    >
                      View</router-link
                    >
                    <!-- {{ item.disbursed_date | date }} -->
                  </td>
                </template>
              </CDataTable>
              <CPagination
                :activePage.sync="loan_next_page"
                :pages="loan_total"
                :onActivePageChange="onLoanPageChange()"
              >
              </CPagination>
            </div>
          </div>
        </div>
      </div>

      <!-- customer card -->
      <div v-if="activetab === 13 && permissions.includes('documents')">
        <Documents :reference="this.slug" />
      </div>  
    </div>
    <two-factor-prompt
      :visible="showTwoFaPrompt"
      :loading="twoFaLoading"
      :description="twoFaDescription"
      :submit-label="twoFaSubmitLabel"
      :loading-text="twoFaLoadingText"
      @close="closeTwoFaPrompt"
      @submit="handleTwoFaSubmit"
    />
  </div>
</template>

<script>
import ApiService from "@/services/api.service";
import ErrorService from "@/services/error.service";
import Swal from "sweetalert2";
import { ChevronLeftIcon } from "vue-feather-icons";
import CScrollbar from "@/components/CScrollbar";
import CCard from "@/components/CCard";
import CPagination from "@/components/CPagination.vue";
import CDataTable from "@/components/CDataTable.vue";
import CModal from "@/components/CModal.vue";
import { CameraIcon } from "vue-feather-icons";
import BankStatement from "@/components/BankStatement";
import Documents from "@/components/Documents";
import KeyValue from "@/components/KeyValue.vue";
import ChangeRequestComponent from "@/views/customers/ChangeRequestComponent.vue";
// import Documents from "../../components/Documents.vue";

const loan_fields = [
  "name",
  "instant_reference",
  "phone",
  "bvn",
  "created_at",
  "review_status",
  "repayment_status",
  "requested_loan_amount",
  "approved_loan_amount",
  "charges",
  "due_date",
  "daily_penalty_fee",
  "tenure",
  "loan_status",
  "disbursed_date",
  "disbursed_status",
  "action"
];

const card_fields = [
  "email",
  "mask_pan",
  "last_four",
  "provider",
  "card_type",
  // "hash_token",
  "created_at"
];

const document_field = [
  "title",
  "description",
  "status",
  "date",
  "action"  
];

const tFields = ["terminalID", "name", "balance", "terminal_status", "action"];
const sFields = [
  "transaction_date",
  "reference_id",
  "narration",
  "amount",
  "credit",
  "debit",
  "opening_balance",
  "balance",
  "reversal_status",
  "is_card",
  "action"
];

const fields = [
  // "created_at",
  "description",
  "transaction_reference",
  "type",
  "status",
  // "method",
  "date",
  "total_amount",
  "actions"
];

const autoSaveFields = [
  "customer_name",
  "title",
  "email",
  "reference",
  "frequency",
  "frequency_amount",
  "actions"
];
const targetFields = [
  "customer_name",
  "title",
  "email",
  "reference",
  "frequency",
  "frequency_amount",
  "actions"
];
const propertyFields = [
  "title",
  "customer_name",
  "email",
  "reference",
  "total_savings",
  "start_date",
  "maturity_date",
  "actions"
];

export default {
  name: "CustomerComponent",
  props: {
    slug: {
      type: [String, Number],
      required: true
    }
  },
  components: {
    BankStatement,
    ChevronLeftIcon,
    ChangeRequestComponent,
    CScrollbar,
    Documents,
    CDataTable,
    CModal,
    CCard,
    CPagination,
    KeyValue,
    "camera-icon": CameraIcon
  },
  computed: {
    psSettings() {
      return {
        maxScrollbarLength: 200,
        minScrollbarLength: 40,
        suppressScrollX:
          getComputedStyle(document.querySelector("html")).direction === "rtl",
        wheelPropagation: false
      };
    },
    formIsValid() {
      return this.type !== "" && this.action !== "" && this.reason !== "";
    },
    statementFormIsValid() {
      return (
        this.acc_number !== "" &&
        this.start_date !== "" &&
        this.stop_date !== ""
      );
    },
    canViewKycLimitOverrides() {
      return (
        this.permissions.includes("view-kyc-limit-overrides") ||
        this.permissions.includes("manage-kyc-limit-overrides")
      );
    },
    kycLimitOverrideFormValid() {
      return (
        this.kycLimitOverride.limit_key !== "" &&
        this.kycLimitOverride.override_value !== "" &&
        this.kycLimitOverride.expires_at !== ""
      );
    },
    permissions() {
      let permissions = this.$store.getters.permissions;
      return permissions;
    },
    twoFaDescription() {
      if (this.twoFaAction === "upgrade-account") {
        return "Enter your authenticator code to upgrade this customer account.";
      }

      if (this.twoFaAction === "reset-password") {
        return "Enter your authenticator code to reset this customer's password.";
      }

      if (this.twoFaAction === "reset-pin") {
        return "Enter your authenticator code to reset this customer's pin.";
      }

      if (this.twoFaAction === "reset-customer-fa") {
        return "Enter your authenticator code to reset this customer's 2FA.";
      }

      if (this.twoFaAction === "release-transfer-hold") {
        return "Enter your authenticator code to temporarily release this hold.";
      }

      if (this.twoFaAction === "clear-transfer-hold") {
        return "Enter your authenticator code to permanently clear this hold.";
      }

      if (this.twoFaAction === "bulk-release-transfer-holds") {
        return `Enter your authenticator code to temporarily release ${this.selectedHoldIds.length} hold(s).`;
      }

      if (this.twoFaAction === "bulk-clear-transfer-holds") {
        return `Enter your authenticator code to permanently clear ${this.selectedHoldIds.length} hold(s).`;
      }

      if (this.twoFaAction === "exclude-transfer-hold") {
        return "Enter your authenticator code to update transfer hold checks for this account.";
      }

      if (this.twoFaAction === "exclude-pattern-check") {
        return "Enter your authenticator code to update transaction pattern checks for this customer.";
      }

      if (this.twoFaAction === "save-kyc-limit-override") {
        return "Enter your authenticator code to set this temporary KYC limit.";
      }

      if (this.twoFaAction === "delete-kyc-limit-override") {
        return "Enter your authenticator code to remove this temporary KYC limit.";
      }

      if (this.twoFaAction === "update-account-app-visibility") {
        if (this.pendingAppVisibilityStatus === "removed") {
          return "Enter your authenticator code to remove this account from the customer app.";
        }
        return "Enter your authenticator code to restore this account to the customer app.";
      }

      return "For security, please enter a fresh code from your authenticator app.";
    },
    twoFaSubmitLabel() {
      if (this.twoFaAction === "upgrade-account") {
        return "Upgrade Account";
      }

      if (this.twoFaAction === "reset-password") {
        return "Reset Password";
      }

      if (this.twoFaAction === "reset-pin") {
        return "Reset Pin";
      }

      if (this.twoFaAction === "reset-customer-fa") {
        return "Reset 2FA";
      }

      if (this.twoFaAction === "release-transfer-hold") {
        return "Release Hold";
      }

      if (this.twoFaAction === "clear-transfer-hold") {
        return "Clear Hold";
      }

      if (this.twoFaAction === "bulk-release-transfer-holds") {
        return "Bulk Release";
      }

      if (this.twoFaAction === "bulk-clear-transfer-holds") {
        return "Bulk Clear";
      }

      if (this.twoFaAction === "exclude-transfer-hold") {
        return "Update Hold Checks";
      }

      if (this.twoFaAction === "exclude-pattern-check") {
        return "Update Pattern Checks";
      }

      if (this.twoFaAction === "save-kyc-limit-override") {
        return "Save Override";
      }

      if (this.twoFaAction === "delete-kyc-limit-override") {
        return "Remove Override";
      }

      if (this.twoFaAction === "update-account-app-visibility") {
        return this.pendingAppVisibilityStatus === "removed"
          ? "Remove from App"
          : "Restore to App";
      }

      return "Verify Code";
    },
    twoFaLoadingText() {
      if (this.twoFaAction === "upgrade-account") {
        return "Upgrading Account...";
      }

      if (this.twoFaAction === "reset-password") {
        return "Resetting Password...";
      }

      if (this.twoFaAction === "reset-pin") {
        return "Resetting Pin...";
      }

      if (this.twoFaAction === "reset-customer-fa") {
        return "Resetting 2FA...";
      }

      if (this.twoFaAction === "release-transfer-hold") {
        return "Releasing hold...";
      }

      if (this.twoFaAction === "clear-transfer-hold") {
        return "Clearing hold...";
      }

      if (this.twoFaAction === "bulk-release-transfer-holds") {
        return "Releasing holds...";
      }

      if (this.twoFaAction === "bulk-clear-transfer-holds") {
        return "Clearing holds...";
      }

      if (this.twoFaAction === "exclude-transfer-hold") {
        return "Updating hold checks...";
      }

      if (this.twoFaAction === "exclude-pattern-check") {
        return "Updating pattern checks...";
      }

      if (this.twoFaAction === "save-kyc-limit-override") {
        return "Saving override...";
      }

      if (this.twoFaAction === "delete-kyc-limit-override") {
        return "Removing override...";
      }

      if (this.twoFaAction === "update-account-app-visibility") {
        return this.pendingAppVisibilityStatus === "removed"
          ? "Removing account..."
          : "Restoring account...";
      }

      return "Verifying...";
    },
    patternChecksExcludedActive() {
      if (!this.customerDetails) {
        return false;
      }

      if (this.customerDetails.exclude_pattern_checks !== "yes") {
        return false;
      }

      if (!this.customerDetails.exclude_pattern_checks_until) {
        return true;
      }

      return (
        new Date(this.customerDetails.exclude_pattern_checks_until) > new Date()
      );
    },
    openTransferHolds() {
      const holds = (this.customerDetails && this.customerDetails.transfer_holds) || [];
      return holds.filter(hold => hold.status !== "cleared");
    },
    transferAttemptCount() {
      return this.openTransferHolds.reduce((max, hold) => {
        const attempts = Number(hold.blocked_attempts || 0);
        return attempts > max ? attempts : max;
      }, 0);
    },
    allOpenHoldsSelected() {
      return (
        this.openTransferHolds.length > 0 &&
        this.openTransferHolds.every(hold => this.selectedHoldIds.includes(hold.id))
      );
    },
    excludedHoldAccounts() {
      const accounts = (this.customerDetails && this.customerDetails.accounts) || [];
      return accounts.filter(account => account.exclude_transfer_holds === "yes");
    }
  },
  data() {
    return {
      sendMessageObj: {
        title: "",
        message: "",
        type: ""
      },
      photoLoading: false,
      showStDetails: false,
      sFields,
      bvn_image: "",
      acc_number: "",
      start_date: "",
      stop_date: "",
      statement_loading: false,
      statement: null,
      singleStatement: null,
      tFields,
      customerDetails: null,
      approveDocLoading: false,
      card_fields,
      document_field,
      autoSaveFields,
      propertyFields,
      targetFields,
      customerStats: {},
      customerLevels: [],
      customerCards: [],
      complianceDocuments: [
        {
          title: "Operational License",
          description: "Money Lending License",
          status: "pending",
          date: "2023-10-01"
        },
        {
          title: "CAC",
          description: "Corporate Affairs Commission Document",
          status: "approved",
          date: "2023-10-02"
        },
        {
          title: "Shareholding Agreement",
          description: "Shareholding Agreement Document",
          status: "rejected",
          date: "2023-10-03"
        }
      ],
      getCustomerDetailsLoading: false,
      // small: true,
      small: 20,
      activetab: 1,
      isModalVisible: false,
      fields,
      payments: [],
      states: [],
      isApproveDocModalVisible: false,
      isVirtualAccountModalVisible: false,
      isHoldExclusionModalVisible: false,
      holdExclusionReason: "",
      isPatternCheckExclusionModalVisible: false,
      patternCheckExclusionReason: "",
      patternCheckExclusion: {
        exclude_pattern_checks: "no",
        exclude_pattern_checks_until: ""
      },
      type: "",
      updateCustomerLoading: false,
      action: "",
      reason: "",
      autoSavePlans: [],
      aTotal: 1,
      aNext_page: 2,
      aCurrent: 1,
      propertyPlans: [],
      pTotal: 1,
      pNext_page: 2,
      pCurrent: 1,
      targetPlans: [],
      tTotal: 1,
      tNext_page: 2,
      tCurrent: 1,
      payments: [],
      total: 1,
      next_page: 1,
      current: 1,
      accountLoading: false,
      isUpgradeAccountModalVisible: false,
      isKycLimitOverrideModalVisible: false,
      kycLimitOptions: [],
      kycLimitOverrides: [],
      pendingKycLimitOverrideId: null,
      kycLimitOverride: {
        limit_key: "",
        override_value: "",
        expires_at: "",
        reason: ""
      },
      upgradeAccountLoading: false,
      kyc_level_id: null,
      showImageVisible: false,
      imageModalQuery: "",
      rpLoading: false,
      resetType: "",
      images: [],
      isSendMessageModalVisible: false,
      isEnterpriseModalVisible: false,
      sendMessageLoading: false,
      pushCbaLoading: false,
      loanProducts: [],
      loan_next_page: 1,
      loan_total: 1,
      loan_current: 1,
      loan_fields,
      addAccountToCustomerModal: false,
      addAccountToCustomerDetail: null,
      cba_account_number: "",
      get_cba_account_detail_loading: false,
      selectedAccount: null,
      aiBtnLoading: false,
      voiceRemimderLoader: false,
  isAiBlocksModalVisible: false,
  changeRequestCustomerId: null,
  showTwoFaPrompt: false,
  twoFaLoading: false,
  twoFaAction: null,
  reset2faLoading: false,
  pendingHold: null,
  pendingHoldHours: 1,
  pendingClearReason: "",
  selectedHoldIds: [],
  pendingAppVisibilityAccount: null,
  pendingAppVisibilityStatus: "removed",
    };
  },
  methods: {
    showAiBlocksModal() {
      this.isAiBlocksModalVisible = true;
    },
    closeAiBlocksModal() {
      this.isAiBlocksModalVisible = false;
    },
    showAddAccountToCustomerModal() {
      this.addAccountToCustomerModal = true;
    },
    closeAddAccountToCustomerModal() {
      this.addAccountToCustomerModal = false;
      this.addAccountToCustomerDetail = null;
    },
    async updateVirtualAccountPrefix() {
      try {
        this.sendMessageLoading = true;
        console.log(this.sendMessageObj);
        const response = await ApiService.post(
          `account/update_virtual_account_prefix/${this.selectedAccount.uuid}`,
          {
            virtual_account_usage: this.selectedAccount.virtual_account_usage,
            virtual_account_prefix: this.selectedAccount.virtual_account_prefix
          }
        );
        Swal.fire({
          title: "Success",
          text: response.data.message,
          icon: "success",
          timer: 3000,
          confirmButtonText: "Close",
          showConfirmButton: false
        });
        this.sendMessageLoading = false;
        this.closeVirtualAccountModal();
        this.getCustomerDetails();
      } catch (error) {
        this.sendMessageLoading = false;
        console.log(error.response);
        this.closeVirtualAccountModal();
        let _error = error.response.data;
        ErrorService.displayErrorAlert(_error);
      }
    },
    async updateEnterpriseAccess() {
      try {
        this.sendMessageLoading = true;
        console.log(this.sendMessageObj);
        const response = await ApiService.post(
          `customer/update_enterprise_access/${this.slug}`,
          {
            is_enterprise_account: this.customerDetails.is_enterprise_account,
            is_enterprise_virtual_account: this.customerDetails.is_enterprise_virtual_account
          }
        );
        Swal.fire({
          title: "Success",
          text: response.data.message,
          icon: "success",
          timer: 3000,
          confirmButtonText: "Close",
          showConfirmButton: false
        });
        this.sendMessageLoading = false;
        this.closeEnterpriseModal();
        this.getCustomerDetails();
      } catch (error) {
        this.sendMessageLoading = false;
        console.log(error.response);
        this.closeEnterpriseModal();
        let _error = error.response.data;
        ErrorService.displayErrorAlert(_error);
      }
    },
    async sendMessageProcess() {
      try {
        this.sendMessageLoading = true;
        console.log(this.sendMessageObj);
        const response = await ApiService.post(
          `customer/send_message/${this.slug}`,
          this.sendMessageObj
        );
        Swal.fire({
          title: "Success",
          text: response.data.message,
          icon: "success",
          timer: 3000,
          confirmButtonText: "Close",
          showConfirmButton: false
        });
        this.sendMessageLoading = false;
        this.closeSendMessageModal();
      } catch (error) {
        this.sendMessageLoading = false;
        console.log(error.response);
        this.closeSendMessageModal();
        let _error = error.response.data;
        ErrorService.displayErrorAlert(_error);
      }
    },
    closeSendMessageModal() {
      this.isSendMessageModalVisible = false;
    },
    openSendMessageModal() {
      this.sendMessageObj.title = "";
      this.sendMessageObj.type = "";
      this.sendMessageObj.message = "";
      this.isSendMessageModalVisible = true;
    },
    openEnterpriseModal() {
      this.isEnterpriseModalVisible = true;
    },
    closeEnterpriseModal() {
      this.isEnterpriseModalVisible = false;
    },
    openVirtualAccountModal(account) {
      this.selectedAccount = account;
      this.isVirtualAccountModalVisible = true;
    },
    closeVirtualAccountModal() {
      this.selectedAccount = null;
      this.isVirtualAccountModalVisible = false;
    },
    openHoldExclusionModal(account) {
      this.selectedAccount = Object.assign({}, account, {
        exclude_transfer_holds: account.exclude_transfer_holds || "no"
      });
      this.holdExclusionReason = "";
      this.isHoldExclusionModalVisible = true;
    },
    closeHoldExclusionModal() {
      if (!this.showTwoFaPrompt) {
        this.selectedAccount = null;
      }
      this.isHoldExclusionModalVisible = false;
    },
    openPatternCheckExclusionModal() {
      const until = this.customerDetails.exclude_pattern_checks_until;
      this.patternCheckExclusion = {
        exclude_pattern_checks:
          this.customerDetails.exclude_pattern_checks || "no",
        exclude_pattern_checks_until: until
          ? until.replace(" ", "T").slice(0, 16)
          : ""
      };
      this.patternCheckExclusionReason =
        this.customerDetails.exclude_pattern_checks_reason || "";
      this.isPatternCheckExclusionModalVisible = true;
    },
    closePatternCheckExclusionModal() {
      if (!this.showTwoFaPrompt) {
        this.patternCheckExclusion = {
          exclude_pattern_checks: "no",
          exclude_pattern_checks_until: ""
        };
        this.patternCheckExclusionReason = "";
      }
      this.isPatternCheckExclusionModalVisible = false;
    },
    promptSavePatternCheckExclusion() {
      this.isPatternCheckExclusionModalVisible = false;
      this.twoFaAction = "exclude-pattern-check";
      this.showTwoFaPrompt = true;
    },
    async confirmSavePatternCheckExclusion(code) {
      try {
        this.twoFaLoading = true;
        const response = await ApiService.post(
          `customer/exclude-pattern-checks/${this.customerDetails.id}`,
          {
            exclude_pattern_checks:
              this.patternCheckExclusion.exclude_pattern_checks,
            exclude_pattern_checks_until:
              this.patternCheckExclusion.exclude_pattern_checks === "yes" &&
              this.patternCheckExclusion.exclude_pattern_checks_until
                ? this.patternCheckExclusion.exclude_pattern_checks_until.replace(
                    "T",
                    " "
                  ) + ":00"
                : null,
            reason: this.patternCheckExclusionReason,
            code
          }
        );
        this.twoFaLoading = false;
        this.closeTwoFaPrompt(true);
        this.patternCheckExclusion = {
          exclude_pattern_checks: "no",
          exclude_pattern_checks_until: ""
        };
        this.patternCheckExclusionReason = "";
        Swal.fire({
          title: "Success",
          text: response.data.message,
          icon: "success",
          timer: 3000,
          confirmButtonText: "Close",
          showConfirmButton: false
        });
        this.getCustomerDetails();
      } catch (error) {
        this.twoFaLoading = false;
        let _error = error.response && error.response.data;
        if (_error) {
          ErrorService.displayErrorAlert(_error);
        }
      }
    },
    promptSaveHoldExclusion() {
      if (!this.selectedAccount) {
        return;
      }

      this.isHoldExclusionModalVisible = false;
      this.twoFaAction = "exclude-transfer-hold";
      this.showTwoFaPrompt = true;
    },
    async confirmSaveHoldExclusion(code) {
      try {
        this.twoFaLoading = true;
        const response = await ApiService.post(
          `customer/exclude-transfer-holds/${this.selectedAccount.uuid}`,
          {
            exclude_transfer_holds: this.selectedAccount.exclude_transfer_holds,
            reason: this.holdExclusionReason,
            code
          }
        );
        this.twoFaLoading = false;
        this.closeTwoFaPrompt(true);
        this.selectedAccount = null;
        this.holdExclusionReason = "";
        Swal.fire({
          title: "Success",
          text: response.data.message,
          icon: "success",
          timer: 3000,
          confirmButtonText: "Close",
          showConfirmButton: false
        });
        this.getCustomerDetails();
      } catch (error) {
        this.twoFaLoading = false;
        let _error = error.response && error.response.data;
        if (_error) {
          ErrorService.displayErrorAlert(_error);
        }
      }
    },
    promptUpdateAccountAppVisibility(account, status) {
      const removing = status === "removed";
      Swal.fire({
        title: removing ? "Remove account from app?" : "Restore account to app?",
        text: removing
          ? `${account.account_number} will no longer be listed in the customer's app.`
          : `${account.account_number} will be listed in the customer's app again.`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Continue"
      }).then(result => {
        if (result.isConfirmed) {
          this.pendingAppVisibilityAccount = account;
          this.pendingAppVisibilityStatus = status;
          this.twoFaAction = "update-account-app-visibility";
          this.showTwoFaPrompt = true;
        }
      });
    },
    async confirmUpdateAccountAppVisibility(code) {
      if (!this.pendingAppVisibilityAccount || !this.pendingAppVisibilityAccount.account_number) {
        return;
      }

      try {
        this.twoFaLoading = true;
        const response = await ApiService.post(
          `account/update-app-visibility/${this.pendingAppVisibilityAccount.account_number}`,
          {
            account_status: this.pendingAppVisibilityStatus,
            code
          }
        );
        this.twoFaLoading = false;
        this.closeTwoFaPrompt(true);
        this.pendingAppVisibilityAccount = null;
        Swal.fire({
          title: "Success",
          text: response.data.message,
          icon: "success",
          timer: 3000,
          confirmButtonText: "Close",
          showConfirmButton: false
        });
        this.getCustomerDetails();
      } catch (error) {
        this.twoFaLoading = false;
        let _error = error.response && error.response.data;
        if (_error) {
          ErrorService.displayErrorAlert(_error);
        }
      }
    },
    resetPassword(type) {
      this.resetType = type;
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-success",
          cancelButton: "btn btn-danger me-2",
          title: "text-center h6 fw-bold text-black d-block"
        },
        buttonStyling: false
      });
      swalWithBootstrapButtons
        .fire({
          title: `Are you sure you want to reset  ${this.customerDetails.last_name} ${this.customerDetails.first_name}'s ${this.resetType}`,
          text: "You won't be able to revert",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes, continue!",
          cancelButtonText: "No Cancel",
          reverseButtons: true
        })
        .then(result => {
          if (result.isConfirmed) {
            this.twoFaAction = `reset-${this.resetType}`;
            this.showTwoFaPrompt = true;
          } else if (result.dismiss == Swal.DismissReason.cancel) {
            swalWithBootstrapButtons.fire("Cancelled", "", "error");
          }
        });
    },
    closeTwoFaPrompt(force = false) {
      if (this.twoFaLoading && !force) {
        return;
      }

      this.twoFaLoading = false;
      this.showTwoFaPrompt = false;
      this.twoFaAction = null;
    },
    handleTwoFaSubmit(code) {
      if (this.twoFaAction === "upgrade-account") {
        this.confirmUpgradeAccount(code);
      } else if (
        this.twoFaAction === "reset-password" ||
        this.twoFaAction === "reset-pin"
      ) {
        this.confirmResetPassword(code);
      } else if (this.twoFaAction === "reset-customer-fa") {
        this.confirmResetCustomer2FA(code);
      } else if (this.twoFaAction === "release-transfer-hold") {
        this.confirmReleaseHold(code);
      } else if (this.twoFaAction === "clear-transfer-hold") {
        this.confirmClearHold(code);
      } else if (this.twoFaAction === "bulk-release-transfer-holds") {
        this.confirmBulkReleaseHolds(code);
      } else if (this.twoFaAction === "bulk-clear-transfer-holds") {
        this.confirmBulkClearHolds(code);
      } else if (this.twoFaAction === "exclude-transfer-hold") {
        this.confirmSaveHoldExclusion(code);
      } else if (this.twoFaAction === "exclude-pattern-check") {
        this.confirmSavePatternCheckExclusion(code);
      } else if (this.twoFaAction === "save-kyc-limit-override") {
        this.confirmSaveKycLimitOverride(code);
      } else if (this.twoFaAction === "delete-kyc-limit-override") {
        this.confirmDeleteKycLimitOverride(code);
      } else if (this.twoFaAction === "update-account-app-visibility") {
        this.confirmUpdateAccountAppVisibility(code);
      }
    },
    promptReleaseHold(hold) {
      Swal.fire({
        title: "Release transfer hold",
        input: "number",
        inputLabel: "Hours (1-72)",
        inputValue: 1,
        inputAttributes: { min: 1, max: 72 },
        showCancelButton: true,
        confirmButtonText: "Continue"
      }).then(result => {
        if (result.isConfirmed) {
          const hours = parseInt(result.value, 10);
          if (!hours || hours < 1 || hours > 72) {
            Swal.fire("Invalid hours", "Enter a value between 1 and 72", "error");
            return;
          }
          this.pendingHold = hold;
          this.pendingHoldHours = hours;
          this.twoFaAction = "release-transfer-hold";
          this.showTwoFaPrompt = true;
        }
      });
    },
    promptClearHold(hold) {
      Swal.fire({
        title: "Clear hold permanently",
        input: "text",
        inputLabel: "Reason",
        inputPlaceholder: "Why is this hold being cleared?",
        showCancelButton: true,
        confirmButtonText: "Continue"
      }).then(result => {
        if (result.isConfirmed) {
          if (!result.value) {
            Swal.fire("Reason required", "", "error");
            return;
          }
          this.pendingHold = hold;
          this.pendingClearReason = result.value;
          this.twoFaAction = "clear-transfer-hold";
          this.showTwoFaPrompt = true;
        }
      });
    },
    async confirmReleaseHold(code) {
      this.twoFaLoading = true;
      try {
        const response = await ApiService.post(
          `customer/release-transfer-hold/${this.pendingHold.id}`,
          { hours: this.pendingHoldHours, code }
        );
        Swal.fire("Success", response.data.message, "success");
        this.closeTwoFaPrompt(true);
        this.getCustomerDetails();
      } catch (error) {
        this.twoFaLoading = false;
        ErrorService.onError(error);
      }
    },
    async confirmClearHold(code) {
      this.twoFaLoading = true;
      try {
        const response = await ApiService.post(
          `customer/clear-transfer-hold/${this.pendingHold.id}`,
          { reason: this.pendingClearReason, code }
        );
        Swal.fire("Success", response.data.message, "success");
        this.closeTwoFaPrompt(true);
        this.getCustomerDetails();
      } catch (error) {
        this.twoFaLoading = false;
        ErrorService.onError(error);
      }
    },
    toggleHoldSelection(id, checked) {
      if (checked) {
        if (!this.selectedHoldIds.includes(id)) {
          this.selectedHoldIds = this.selectedHoldIds.concat(id);
        }
        return;
      }
      this.selectedHoldIds = this.selectedHoldIds.filter(holdId => holdId !== id);
    },
    toggleSelectAllHolds(checked) {
      if (checked) {
        this.selectedHoldIds = this.openTransferHolds.map(hold => hold.id);
        return;
      }
      this.selectedHoldIds = [];
    },
    promptBulkReleaseHolds() {
      if (!this.selectedHoldIds.length) {
        return;
      }
      Swal.fire({
        title: `Release ${this.selectedHoldIds.length} hold(s)`,
        input: "number",
        inputLabel: "Hours (1-72)",
        inputValue: 1,
        inputAttributes: { min: 1, max: 72 },
        showCancelButton: true,
        confirmButtonText: "Continue"
      }).then(result => {
        if (result.isConfirmed) {
          const hours = parseInt(result.value, 10);
          if (!hours || hours < 1 || hours > 72) {
            Swal.fire("Invalid hours", "Enter a value between 1 and 72", "error");
            return;
          }
          this.pendingHoldHours = hours;
          this.twoFaAction = "bulk-release-transfer-holds";
          this.showTwoFaPrompt = true;
        }
      });
    },
    promptBulkClearHolds() {
      if (!this.selectedHoldIds.length) {
        return;
      }
      Swal.fire({
        title: `Clear ${this.selectedHoldIds.length} hold(s) permanently`,
        input: "text",
        inputLabel: "Reason",
        inputPlaceholder: "Why are these holds being cleared?",
        showCancelButton: true,
        confirmButtonText: "Continue"
      }).then(result => {
        if (result.isConfirmed) {
          if (!result.value) {
            Swal.fire("Reason required", "", "error");
            return;
          }
          this.pendingClearReason = result.value;
          this.twoFaAction = "bulk-clear-transfer-holds";
          this.showTwoFaPrompt = true;
        }
      });
    },
    async confirmBulkReleaseHolds(code) {
      this.twoFaLoading = true;
      try {
        const response = await ApiService.post("customer/bulk-release-transfer-holds", {
          hold_ids: this.selectedHoldIds,
          hours: this.pendingHoldHours,
          code
        });
        Swal.fire("Success", response.data.message, "success");
        this.closeTwoFaPrompt(true);
        this.selectedHoldIds = [];
        this.getCustomerDetails();
      } catch (error) {
        this.twoFaLoading = false;
        ErrorService.onError(error);
      }
    },
    async confirmBulkClearHolds(code) {
      this.twoFaLoading = true;
      try {
        const response = await ApiService.post("customer/bulk-clear-transfer-holds", {
          hold_ids: this.selectedHoldIds,
          reason: this.pendingClearReason,
          code
        });
        Swal.fire("Success", response.data.message, "success");
        this.closeTwoFaPrompt(true);
        this.selectedHoldIds = [];
        this.getCustomerDetails();
      } catch (error) {
        this.twoFaLoading = false;
        ErrorService.onError(error);
      }
    },
    resetCustomer2FA() {
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-success",
          cancelButton: "btn btn-danger me-2",
          title: "text-center h6 fw-bold text-black d-block"
        },
        buttonStyling: false
      });
      swalWithBootstrapButtons
        .fire({
          title: `Are you sure you want to reset ${this.customerDetails.last_name} ${this.customerDetails.first_name}'s 2FA?`,
          text: "The customer will need to set up 2FA again on their next login.",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes, continue!",
          cancelButtonText: "No Cancel",
          reverseButtons: true
        })
        .then(result => {
          if (result.isConfirmed) {
            this.twoFaAction = "reset-customer-fa";
            this.showTwoFaPrompt = true;
          } else if (result.dismiss == Swal.DismissReason.cancel) {
            swalWithBootstrapButtons.fire("Cancelled", "", "error");
          }
        });
    },
    async addAccountToCustomer(type) {
      try {
        //validate the account number
        if (this.cba_account_number == "") {
          Swal.fire({
            title: "Error",
            text: "Please enter a valid account number",
            icon: "error",
            timer: 3000,
            confirmButtonText: "Close",
            showConfirmButton: false
          });
          return;
        }

        if (type == "submit") {
          this.addAccountToCustomerModal = false;
          const swalResponse = await Swal.fire({
            title: `<div>
                    <h5 class="font-weight-600">Are you sure want to add account to this customer profile?</h5>
                  </div>`,
            text: "You are about to create an account",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, create it!"
          });

          if (!swalResponse.isConfirmed) {
            return;
          }

          this.get_cba_account_detail_loading = true;
        }

        let body = {
          user_id: this.slug,
          account_number: this.cba_account_number,
          type: type
        };

        const respose = await ApiService.post(
          `account/add_account_to_customer`,
          body
        );
        console.log("====================================");
        console.log(respose.data);
        console.log("====================================");
        this.addAccountToCustomerDetail = respose.data.data;

        Swal.fire({
          title: "Success",
          text: respose.data.message,
          icon: "success",
          timer: 3000,
          confirmButtonText: "Close",
          showConfirmButton: false
        });
        this.get_cba_account_detail_loading = false;

        if (type == "submit") {
          this.closeAddAccountToCustomerModal();
          getCustomerDetails();
        }
      } catch (error) {
        this.get_cba_account_detail_loading = false;
        console.log(error.response);
        let _error = error.response.data;
        ErrorService.displayErrorAlert(_error);
      }
    },

    async confirmResetPassword(code) {
      this.rpLoading = true;
      this.twoFaLoading = true;

      try {
        const response = await ApiService.post(
          `customer/reset-${this.resetType}-directly/${this.slug}`,
          { code }
        );
        Swal.fire({
          title: "Success",
          text: response.data.message,
          icon: "success",
          timer: 3000,
          confirmButtonText: "Close",
          showConfirmButton: false
        });
        this.rpLoading = false;
        this.twoFaLoading = false;
        this.closeTwoFaPrompt();
      } catch (error) {
        this.rpLoading = false;
        this.closeTwoFaPrompt(true);
        console.log(error.response);
        let _error = error.response.data;
        ErrorService.displayErrorAlert(_error);
      }
    },
    async confirmResetCustomer2FA(code) {
      this.reset2faLoading = true;
      this.twoFaLoading = true;

      try {
        const response = await ApiService.post(
          `customer/reset-fa/${this.slug}`,
          { code }
        );
        Swal.fire({
          title: "Success",
          text: response.data.message,
          icon: "success",
          timer: 3000,
          confirmButtonText: "Close",
          showConfirmButton: false
        });
        this.reset2faLoading = false;
        this.twoFaLoading = false;
        this.closeTwoFaPrompt();
        this.getCustomerDetails();
      } catch (error) {
        this.reset2faLoading = false;
        this.closeTwoFaPrompt(true);
        console.log(error.response);
        let _error = error.response.data;
        ErrorService.displayErrorAlert(_error);
      }
    },

    updateCustomerToCBA() {
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-success",
          cancelButton: "btn btn-danger me-2",
          title: "text-center h6 fw-bold text-black d-block"
        },
        buttonStyling: false
      });
      swalWithBootstrapButtons
        .fire({
          title: `Are you sure you want to push  Customer Details to CBA`,
          text: "You won't be able to revert",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes, continue!",
          cancelButtonText: "No Cancel",
          reverseButtons: true
        })
        .then(async result => {
          if (result.isConfirmed) {
            // this.showUpdateModal = true;
            try {
              console.log(this.sendMessageObj);
              const response = await ApiService.get(
                `customer/update_customer_info_on_cba/${this.slug}`,
                this.sendMessageObj
              );
              Swal.fire({
                title: "Success",
                text: response.data.message,
                icon: "success",
                timer: 3000,
                confirmButtonText: "Close",
                showConfirmButton: false
              });
              this.sendMessageLoading = false;
            } catch (error) {
              this.sendMessageLoading = false;
              console.log(error.response);
              let _error = error.response.data;
              ErrorService.displayErrorAlert(_error);
            }
          } else if (result.dismiss == Swal.DismissReason.cancel) {
            swalWithBootstrapButtons.fire("Cancelled", "", "error");
          }
        });
    },

    updateCustomerIDToCBA() {
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-success",
          cancelButton: "btn btn-danger me-2",
          title: "text-center h6 fw-bold text-black d-block"
        },
        buttonStyling: false
      });
      swalWithBootstrapButtons
        .fire({
          title: `Are you sure you want to push  Customer ID to CBA`,
          text: "You won't be able to revert",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes, continue!",
          cancelButtonText: "No Cancel",
          reverseButtons: true
        })
        .then(async result => {
          if (result.isConfirmed) {
            // this.showUpdateModal = true;
            try {
              console.log(this.sendMessageObj);
              const response = await ApiService.get(
                `customer/update_customer_id_on_cba/${this.slug}`,
                this.sendMessageObj
              );
              Swal.fire({
                title: "Success",
                text: response.data.message,
                icon: "success",
                timer: 3000,
                confirmButtonText: "Close",
                showConfirmButton: false
              });
              this.sendMessageLoading = false;
            } catch (error) {
              this.sendMessageLoading = false;
              console.log(error.response);
              let _error = error.response.data;
              ErrorService.displayErrorAlert(_error);
            }
          } else if (result.dismiss == Swal.DismissReason.cancel) {
            swalWithBootstrapButtons.fire("Cancelled", "", "error");
          }
        });
    },

    async pushCustomerInfoToCBA() {},
    closeImageModal() {
      this.imageModalQuery = "";
      this.showImageVisible = false;
    },
    openImageModal(param) {
      this.images = [];
      this.$viewerApi({
        images: [param]
      });
      this.images.push(param);
      console.log(this.images);
      // this.photoLoading = true;
      console.log(param);
      setTimeout(() => this.setImage(param), 4000);
    },
    setImage(param) {
      this.imageModalQuery = param;
      // this.photoLoading = false;
      // this.showImageVisible = true;
    },
    closeStModal() {
      this.showStDetails = false;
      this.singleStatement = null;
    },
    openStModal(item) {
      console.log(item);
      this.singleStatement = item;
      this.showStDetails = true;
    },
    async getStatement() {
      this.statement_loading = true;
      try {
        let response = await ApiService.post("payment/statement", {
          start_date: this.start_date,
          end_date: this.stop_date,
          account_number: this.acc_number
        });
        this.statement = response.data.data;
        this.statement_loading = false;
      } catch (error) {
        console.log(error.response);
        this.statement_loading = false;
        ErrorService.displayErrorAlert(error.response.data);
      }
    },
    async revealBalance(account_number) {
      this.accountLoading = true;
      try {
        let response = await ApiService.post(`account/balance`, {
          account_number: account_number
        });
        this.accountLoading = false;
        Swal.fire({
          title: "Account Balance",
          text: `₦${response.data.data.available_balance}`,
          icon: "success",
          confirmButtonText: "Ok"
        });
      } catch (error) {
        this.accountLoading = false;
        ErrorService.displayErrorAlert(error.response.data);
      }
    },
    openUpgradeAccountModal() {
      this.isUpgradeAccountModalVisible = true;
    },
    closeUpgradeAccountModal() {
      this.isUpgradeAccountModalVisible = false;
      this.type = "";
      this.action = "";
      this.reason = "";
    },
    upgradeProcess() {
      this.isUpgradeAccountModalVisible = false;
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-success",
          cancelButton: "btn btn-danger me-2",
          title: "text-center h6 fw-bold text-black d-block"
        },
        buttonStyling: false
      });
      swalWithBootstrapButtons
        .fire({
          title: `Are you sure you want to upgrade this account`,
          text: "You won't be able to revert",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes, continue!",
          cancelButtonText: "No Cancel",
          reverseButtons: true
        })
        .then(result => {
          if (result.isConfirmed) {
            this.$nextTick(() => {
              this.twoFaAction = "upgrade-account";
              this.showTwoFaPrompt = true;
            });
          } else if (result.dismiss == Swal.DismissReason.cancel) {
            swalWithBootstrapButtons.fire("Cancelled", "", "error");
          }
        });
    },
    async confirmUpgradeAccount(code) {
      let data = {
        customer_id: this.slug,
        kyc_level_id: this.kyc_level_id,
        code
      };

      try {
        this.upgradeAccountLoading = true;
        this.twoFaLoading = true;
        const response = await ApiService.post(
          "customer/upgrade-customer-level",
          data
        );
        this.upgradeAccountLoading = false;
        this.twoFaLoading = false;
        this.closeTwoFaPrompt();
        this.closeUpgradeAccountModal();
        Swal.fire({
          title: "Success",
          text: response.data.response_message,
          icon: "success",
          timer: 3000,
          confirmButtonText: "Close",
          showConfirmButton: false
        });
        setTimeout(() => this.getCustomerDetails(), 2000);
      } catch (error) {
        console.log(error.response);
        this.upgradeAccountLoading = false;
        this.closeTwoFaPrompt(true);
        let _error = error.response.data;
        console.log(_error.message);
        Swal.fire({
          title: "Error!",
          text: _error.message,
          icon: "error",
          confirmButtonText: "Close"
        });
      }
    },
    openApproveDocModal() {
      this.isApproveDocModalVisible = true;
    },
    closeApproveDocModal() {
      this.isApproveDocModalVisible = false;
      this.type = "";
      this.action = "";
      this.reason = "";
    },
    showApproveDocModal(type) {
      this.type = type;
      this.openApproveDocModal();
    },
    approveProcess() {
      // this.isUpgradeAccountModalVisible = false;
      this.isApproveDocModalVisible = false;
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-success",
          cancelButton: "btn btn-danger me-2",
          title: "text-center h6 fw-bold text-black d-block"
        },
        buttonStyling: false
      });
      swalWithBootstrapButtons
        .fire({
          title: `Are you sure you want to perform this action on ${this.customerDetails.last_name} ${this.customerDetails.first_name}'s document type  `,
          text: "You won't be able to revert",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes, continue!",
          cancelButtonText: "No Cancel",
          reverseButtons: true
        })
        .then(result => {
          if (result.isConfirmed) {
            this.isApproveDocModalVisible = true;

            this.approveDoc();
          } else if (result.dismiss == Swal.DismissReason.cancel) {
            swalWithBootstrapButtons.fire("Cancelled", "", "error");
            // this.showUpdateModal = true;
          }
        });
    },
    async verifyIdWithAI() {
      this.aiBtnLoading = true;
      try {
        const response = await ApiService.post(
          `customer/verify_id_with_ai`,{
            id: this.slug,
          }
        );
        this.aiBtnLoading = false;
        Swal.fire({
          title: "Success",
          text: response.data.message,
          icon: "success",
          timer: 3000,
          confirmButtonText: "Close",
          showConfirmButton: false
        });
        setTimeout(() => this.getCustomerDetails(), 3000);
      } catch (error) {
        this.aiBtnLoading = false;
        console.log(error.response);
        let _error = error.response.data;
        ErrorService.displayErrorAlert(_error);
        setTimeout(() => this.getCustomerDetails(), 3000);
      }
    },
    async sendVoiceRemimder() {
      this.voiceRemimderLoader = true;
      try {
        const response = await ApiService.post(
          `customer/send_voice_reminders`,{
            id: this.slug,
          }
        );
        this.voiceRemimderLoader = false;
        Swal.fire({
          title: "Success",
          text: response.data.message,
          icon: "success",
          timer: 3000,
          confirmButtonText: "Close",
          showConfirmButton: false
        });
        setTimeout(() => this.getCustomerDetails(), 3000);
      } catch (error) {
        this.voiceRemimderLoader = false;
        console.log(error.response);
        let _error = error.response.data;
        ErrorService.displayErrorAlert(_error);
        setTimeout(() => this.getCustomerDetails(), 3000);
      }
    },
    async approveDoc() {
      let data = {
        customer_id: this.slug,
        type: this.type,
        action: this.action,
        reason: this.reason
      };
      console.log(data);
      try {
        this.approveDocLoading = true;
        const response = await ApiService.post(
          "customer/treat-customer-kyc",
          data
        );
        this.approveDocLoading = false;
        this.closeApproveDocModal();
        Swal.fire({
          title: "Success",
          text: response.data.response_message,
          icon: "success",
          timer: 3000,
          confirmButtonText: "Close",
          showConfirmButton: false
        });

        setTimeout(() => this.getCustomerDetails(), 3000);

        // this.getCustomerDetails();

        console.log(data);
      } catch (error) {
        console.log(error.response);
        this.closeApproveDocModal();
        this.approveDocLoading = false;
        let _error = error.response.data;
        console.log(_error.message);
        Swal.fire({
          title: "Error!",
          text: _error.message,
          icon: "error",
          confirmButtonText: "Close"
        });
        // let _error = error.response.data;
        // ErrorService.displayErrorAlert(_error);
      }
    },
    async getCustomerDetails() {
      try {
        this.getCustomerDetailsLoading = true;
        const response = await ApiService.get(
          `customer/view-customer/${this.slug}`
        );
        this.customerDetails = response.data.data;
  this.changeRequestCustomerId = this.customerDetails && (this.customerDetails.id || this.customerDetails.user_id) || null;
        this.customerCards = this.customerDetails.cards;
        this.kyc_level_id = this.customerDetails.kyc.kyc_level_id;
        this.getCustomerDetailsLoading = false;
        if (this.canViewKycLimitOverrides) {
          this.loadKycLimitOverrides();
        }
      } catch (error) {
        console.log(error.response);
        this.getCustomerDetailsLoading = false;
      }
    },
    async loadKycLimitOverrides() {
      if (!this.customerDetails || !this.customerDetails.id) return;
      try {
        const response = await ApiService.get(
          `customer/kyc-limit-overrides/${this.customerDetails.id}`
        );
        const payload = response.data.data || {};
        this.kycLimitOptions = payload.limits || [];
        this.kycLimitOverrides = payload.overrides || [];
      } catch (error) {
        console.log(error && error.response);
      }
    },
    openKycLimitOverrideModal() {
      this.kycLimitOverride = {
        limit_key: "",
        override_value: "",
        expires_at: "",
        reason: ""
      };
      this.isKycLimitOverrideModalVisible = true;
      if (!this.kycLimitOptions.length) {
        this.loadKycLimitOverrides();
      }
    },
    closeKycLimitOverrideModal() {
      this.isKycLimitOverrideModalVisible = false;
    },
    promptSaveKycLimitOverride() {
      if (!this.kycLimitOverrideFormValid) return;
      this.isKycLimitOverrideModalVisible = false;
      this.twoFaAction = "save-kyc-limit-override";
      this.showTwoFaPrompt = true;
    },
    async confirmSaveKycLimitOverride(code) {
      try {
        this.twoFaLoading = true;
        const expires = this.kycLimitOverride.expires_at.replace("T", " ");
        const response = await ApiService.post(
          `customer/kyc-limit-overrides/${this.customerDetails.id}`,
          {
            limit_key: this.kycLimitOverride.limit_key,
            override_value: this.kycLimitOverride.override_value,
            expires_at: expires.length === 16 ? `${expires}:00` : expires,
            reason: this.kycLimitOverride.reason,
            code
          }
        );
        this.twoFaLoading = false;
        this.closeTwoFaPrompt(true);
        Swal.fire({
          title: "Success",
          text: response.data.message,
          icon: "success",
          timer: 3000,
          showConfirmButton: false
        });
        this.loadKycLimitOverrides();
      } catch (error) {
        this.twoFaLoading = false;
        const _error = error.response && error.response.data;
        if (_error) {
          ErrorService.displayErrorAlert(_error);
        }
      }
    },
    promptDeleteKycLimitOverride(item) {
      this.pendingKycLimitOverrideId = item.id;
      this.twoFaAction = "delete-kyc-limit-override";
      this.showTwoFaPrompt = true;
    },
    async confirmDeleteKycLimitOverride(code) {
      try {
        this.twoFaLoading = true;
        const response = await ApiService.post(
          `customer/kyc-limit-overrides/${this.customerDetails.id}/${this.pendingKycLimitOverrideId}/delete`,
          { code }
        );
        this.twoFaLoading = false;
        this.closeTwoFaPrompt(true);
        this.pendingKycLimitOverrideId = null;
        Swal.fire({
          title: "Success",
          text: response.data.message,
          icon: "success",
          timer: 3000,
          showConfirmButton: false
        });
        this.loadKycLimitOverrides();
      } catch (error) {
        this.twoFaLoading = false;
        const _error = error.response && error.response.data;
        if (_error) {
          ErrorService.displayErrorAlert(_error);
        }
      }
    },
    async getBVNImage() {
      try {
        const response = await ApiService.get(
          `customer/get-bvn-image/${this.slug}`
        );
        this.bvn_image = response.data.data;
      } catch (error) {
        console.log(error);
      }
    },
    async getCustomerStat() {
      try {
        const response = await ApiService.get(`stats/customer/${this.slug}`);
        this.customerStats = response.data.data;
      } catch (error) {
        console.log(error);
      }
    },
    async closeModal() {
      this.isModalVisible = false;
      this.customerOrderHistory = {};
    },
    async getStates() {
      try {
        const response = await ApiService.get("utility/state-list");
        this.states = response.data.data;
      } catch (error) {
        console.log(error);
      }
    },
    async updateCustomerProfile() {
      try {
        //referral_code
        // status
        // state_id
        // city
        // address

        this.updateCustomerLoading = true;
        const response = await ApiService.post(
          `/customer/update-customer-full-info/${this.slug}`,
          {
            referral_code: this.customerDetails.referral_code,
            status: this.customerDetails.profile_status,
            state_id: this.customerDetails.kyc.state_id,
            is_marketer: this.customerDetails.is_marketer,
            city: this.customerDetails.kyc.city,
            address: this.customerDetails.kyc.address,
            loan_type: this.customerDetails.loan_profile
              ? this.customerDetails.loan_profile.loan_type
              : null
          }
        );
        this.updateCustomerLoading = false;
        Swal.fire({
          title: "Success",
          text: response.data.response_message,
          icon: "success",
          timer: 3000,
          confirmButtonText: "Close",
          showConfirmButton: false
        });

        setTimeout(() => this.getCustomerDetails(), 3000);
      } catch (error) {
        console.log(error.response);
        this.updateCustomerLoading = false;
        let _error = error.response.data;
        ErrorService.displayErrorAlert(_error);
      }
    },

    async getCustomerTransactions(page) {
      try {
        const response = await ApiService.get(
          `payment/all?page=${page}&user_id=${this.slug}`
        );
        this.payments = response.data.data.data;
        this.current = response.data.data.current_page;
        this.total = response.data.data.last_page;
      } catch (error) {
        console.log(error.response);
      }
    },

    onPageChange() {
      console.log(this.next_page);
      if (this.current !== this.next_page) {
        this.getCustomerTransactions(this.next_page);
      }
    },
    async getCustomerLevels() {
      try {
        this.getCustomerLevelLoading = true;
        const response = await ApiService.get("settings/kyc-levels");
        this.customerLevels = response.data.data;
      } catch (error) {
        console.log(error);
      }
    },
    async allProductLoan(page) {
      this.reportsLoading = true;

      try {
        const response = await ApiService.get(
          `loan/instant/all?page=${page}&user_id=${this.slug}&bypass=yes`
        );
        console.log(response);
        this.loanProducts = response.data.data.data;
        this.loan_current = response.data.data.current_page;
        this.loan_total = response.data.data.last_page;
        this.loanProductsLoading = false;
        this.reportsLoading = false;
      } catch (error) {
        console.log(error.response);
        this.loanProductsLoading = false;
        this.reportsLoading = false;
      } finally {
        this.loanProductsLoading = false;
        this.reportsLoading = false;
      }
    },
    onLoanPageChange() {
      console.log(this.loan_next_page);
      if (this.loan_current != this.loan_next_page) {
        this.allProductLoan(this.loan_next_page);
      }
    }
  },
  mounted() {
    this.getStates();
    this.getCustomerDetails();
    if (this.can("dashboard")) {
      this.getCustomerStat();
    }
    if (this.can("payments")) {
      this.getCustomerTransactions(1);
    }
    if (this.can("kyc-levels") || this.can("upgrade-customer-level")) {
      this.getCustomerLevels();
    }
    if (this.can("view-customer")) {
      this.getBVNImage();
    }
    if (this.can("instant-loans") || this.can("view-instant-loan")) {
      this.allProductLoan(1);
    }
  }
};
</script>

<style scoped>
.id-file {
  width: 80%;
  height: 150px;
  border-radius: 4px;
}
</style>
